// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               v5.26.1
// source: portal/metrics.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../google/protobuf/timestamp";
import { DB } from "./db";

export const protobufPackage = "carbon.portal.metrics";

export enum MetricDataSource {
  UNSPECIFIED = 0,
  CLASSIC = 1,
  JIGSAW = 2,
  UNRECOGNIZED = -1,
}

export function metricDataSourceFromJSON(object: any): MetricDataSource {
  switch (object) {
    case 0:
    case "UNSPECIFIED":
      return MetricDataSource.UNSPECIFIED;
    case 1:
    case "CLASSIC":
      return MetricDataSource.CLASSIC;
    case 2:
    case "JIGSAW":
      return MetricDataSource.JIGSAW;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MetricDataSource.UNRECOGNIZED;
  }
}

export function metricDataSourceToJSON(object: MetricDataSource): string {
  switch (object) {
    case MetricDataSource.UNSPECIFIED:
      return "UNSPECIFIED";
    case MetricDataSource.CLASSIC:
      return "CLASSIC";
    case MetricDataSource.JIGSAW:
      return "JIGSAW";
    case MetricDataSource.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * Which system a plant category id belongs to — where consumers should
 * resolve the id to a display name.
 */
export enum CategorySource {
  /**
   * CATEGORY_SOURCE_UNSPECIFIED - Source unknown: the id belongs to one of the other sources, but the
   * metric labels did not say which and the server could not resolve it —
   * look it up in both.
   */
  CATEGORY_SOURCE_UNSPECIFIED = 0,
  /** CATEGORY_SOURCE_VESELKA - Veselka point category (or the active veselka crop). */
  CATEGORY_SOURCE_VESELKA = 1,
  /** CATEGORY_SOURCE_PLANT_PROFILE_CUSTOM - Customer-authored custom category of the active plant profile. */
  CATEGORY_SOURCE_PLANT_PROFILE_CUSTOM = 2,
  /**
   * CATEGORY_SOURCE_NO_CATEGORY - The key is not a category id in any system — e.g. the robot's UNKNOWN
   * class label or an unmapped detection class name. No lookup will resolve
   * it; display it verbatim or hide it.
   */
  CATEGORY_SOURCE_NO_CATEGORY = 3,
  UNRECOGNIZED = -1,
}

export function categorySourceFromJSON(object: any): CategorySource {
  switch (object) {
    case 0:
    case "CATEGORY_SOURCE_UNSPECIFIED":
      return CategorySource.CATEGORY_SOURCE_UNSPECIFIED;
    case 1:
    case "CATEGORY_SOURCE_VESELKA":
      return CategorySource.CATEGORY_SOURCE_VESELKA;
    case 2:
    case "CATEGORY_SOURCE_PLANT_PROFILE_CUSTOM":
      return CategorySource.CATEGORY_SOURCE_PLANT_PROFILE_CUSTOM;
    case 3:
    case "CATEGORY_SOURCE_NO_CATEGORY":
      return CategorySource.CATEGORY_SOURCE_NO_CATEGORY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CategorySource.UNRECOGNIZED;
  }
}

export function categorySourceToJSON(object: CategorySource): string {
  switch (object) {
    case CategorySource.CATEGORY_SOURCE_UNSPECIFIED:
      return "CATEGORY_SOURCE_UNSPECIFIED";
    case CategorySource.CATEGORY_SOURCE_VESELKA:
      return "CATEGORY_SOURCE_VESELKA";
    case CategorySource.CATEGORY_SOURCE_PLANT_PROFILE_CUSTOM:
      return "CATEGORY_SOURCE_PLANT_PROFILE_CUSTOM";
    case CategorySource.CATEGORY_SOURCE_NO_CATEGORY:
      return "CATEGORY_SOURCE_NO_CATEGORY";
    case CategorySource.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * Grade of entry timing, derived from average weed size (radius in mm).
 * UNSPECIFIED means there is no grade to show.
 */
export enum EntryTimingGrade {
  ENTRY_TIMING_GRADE_UNSPECIFIED = 0,
  ENTRY_TIMING_GRADE_IDEAL = 1,
  ENTRY_TIMING_GRADE_ACCEPTABLE = 2,
  ENTRY_TIMING_GRADE_LATE = 3,
  UNRECOGNIZED = -1,
}

export function entryTimingGradeFromJSON(object: any): EntryTimingGrade {
  switch (object) {
    case 0:
    case "ENTRY_TIMING_GRADE_UNSPECIFIED":
      return EntryTimingGrade.ENTRY_TIMING_GRADE_UNSPECIFIED;
    case 1:
    case "ENTRY_TIMING_GRADE_IDEAL":
      return EntryTimingGrade.ENTRY_TIMING_GRADE_IDEAL;
    case 2:
    case "ENTRY_TIMING_GRADE_ACCEPTABLE":
      return EntryTimingGrade.ENTRY_TIMING_GRADE_ACCEPTABLE;
    case 3:
    case "ENTRY_TIMING_GRADE_LATE":
      return EntryTimingGrade.ENTRY_TIMING_GRADE_LATE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return EntryTimingGrade.UNRECOGNIZED;
  }
}

export function entryTimingGradeToJSON(object: EntryTimingGrade): string {
  switch (object) {
    case EntryTimingGrade.ENTRY_TIMING_GRADE_UNSPECIFIED:
      return "ENTRY_TIMING_GRADE_UNSPECIFIED";
    case EntryTimingGrade.ENTRY_TIMING_GRADE_IDEAL:
      return "ENTRY_TIMING_GRADE_IDEAL";
    case EntryTimingGrade.ENTRY_TIMING_GRADE_ACCEPTABLE:
      return "ENTRY_TIMING_GRADE_ACCEPTABLE";
    case EntryTimingGrade.ENTRY_TIMING_GRADE_LATE:
      return "ENTRY_TIMING_GRADE_LATE";
    case EntryTimingGrade.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface CropMetrics {
  densityPerSquareMeter: number;
  averageRadiusMeters: number;
  found: number;
  thinned: number;
  ignored: number;
  missed: number;
  kept: number;
  categorySource: CategorySource;
  localizedName: string;
}

export interface WeedMetrics {
  fractionOfTotal: number;
  categorySource: CategorySource;
  localizedName: string;
}

/**
 * Weed and crop metrics scoped to one plant profile, to coverage without one,
 * or to categories that could not be attributed to either. JIGSAW data only.
 */
export interface PlantProfileMetrics {
  /**
   * RoSY plant profile (category collection) UUID. Empty when this is the
   * no-plant-profile (thresholds) group or the unattributed group.
   */
  profileId: string;
  /**
   * True when this group holds categories that could not be attributed to any
   * profile (e.g. membership lookups failed while several profiles ran).
   */
  unattributed: boolean;
  /**
   * Profile-scoped analogues of the whole-aggregate weed fields. Densities
   * and averages are 0 when unknown (no attributable coverage / no weeds).
   */
  weedDensityPerSquareMeter: number;
  averageWeedRadiusMeters: number;
  totalWeeds: number;
  totalWeedsInBand: number;
  killedWeeds: number;
  missedWeeds: number;
  skippedWeeds: number;
  /**
   * Same value shapes as the top-level by-category maps, restricted to this
   * group's categories. WeedMetrics.fraction_of_total is relative to this
   * group's total_weeds, so fractions sum to 1 within the group.
   */
  weedMetricsByCategory: { [key: string]: WeedMetrics };
  cropMetricsByCategory: { [key: string]: CropMetrics };
  profileName: string;
  /**
   * Grade from this group's average weed radius. UNSPECIFIED when there are
   * no weeds or the radius is at or below zero.
   */
  entryTimingGrade: EntryTimingGrade;
}

export interface PlantProfileMetrics_WeedMetricsByCategoryEntry {
  key: string;
  value: WeedMetrics | undefined;
}

export interface PlantProfileMetrics_CropMetricsByCategoryEntry {
  key: string;
  value: CropMetrics | undefined;
}

/** One row per robot per calendar day. Dates are represented as YYYY-MM-DD. */
export interface DailyMetricResponse {
  /** base */
  db: DB | undefined;
  serial: string;
  /** @deprecated */
  robotId: number;
  date: string;
  /**
   * prefer jobs
   *
   * @deprecated
   */
  jobId: string;
  /**
   * this will contain the latest job name. use jobs to see all jobs for the
   * given aggregation
   */
  jobName: string;
  /** shared certified fields */
  acresWeeded: number;
  avgSpeedMph: number;
  avgWeedSizeMm: number;
  /**
   * this will contain the latest banding profile name. use banding_profiles to
   * see all profiles for the given aggregation
   */
  bandingConfigName: string;
  bandingEnabled: boolean;
  coverageSpeedAcresHr: number;
  distanceWeededMeters: number;
  killedWeeds: number;
  missedWeeds: number;
  skippedWeeds: number;
  timeEfficiency: number;
  totalWeeds: number;
  uptimeSeconds: number;
  weedDensitySqFt: number;
  weedingUptimeSeconds: number;
  weedingEfficiency: number;
  /**
   * prefer weeds_type_fraction_*
   *
   * @deprecated
   */
  weedsTypeCountBroadleaf: number;
  /** @deprecated */
  weedsTypeCountGrass: number;
  /** @deprecated */
  weedsTypeCountOffshoot: number;
  /** @deprecated */
  weedsTypeCountPurslane: number;
  keptCrops: number;
  missedCrops: number;
  /**
   * not supported in Jigsaw
   *
   * @deprecated
   */
  notThinning: number;
  notWeeding: number;
  skippedCrops: number;
  thinnedCrops: number;
  totalCrops: number;
  bandingPercentage: number;
  thinningEfficiency: number;
  /**
   * prefer crops or latest_crop
   *
   * @deprecated
   */
  cropId: string;
  /**
   * this will not be localized, so prefer to lookup the proper local name based
   * on crop_id
   *
   * @deprecated
   */
  crop: string;
  cropDensitySqFt: number;
  avgCropSizeMm: number;
  avgTargetableReqLaserTime: number;
  /**
   * not supported in Jigsaw
   *
   * @deprecated
   */
  avgUntargetableReqLaserTime: number;
  validCrops: number;
  operatorEffectiveness: number;
  targetWeedingTimeSeconds: number;
  /**
   * not supported in Jigsaw
   *
   * @deprecated
   */
  embeddingsActiveUptimeSeconds: number;
  customerId: string;
  dataSource: MetricDataSource;
  bandingProfiles: JigsawBandingProfile[];
  crops: JigsawCrop[];
  jobs: JigsawJob[];
  overallEfficiency: number;
  totalWeedsInBand: number;
  /**
   * fraction (0-1) of categorized weeds in each category
   *
   * @deprecated
   */
  weedsTypeFractionBroadleaf: number;
  /** @deprecated */
  weedsTypeFractionGrass: number;
  /** @deprecated */
  weedsTypeFractionOffshoot: number;
  /** @deprecated */
  weedsTypeFractionPurslane: number;
  /**
   * daily specific
   * not supported in Jigsaw
   *
   * @deprecated
   */
  notWeedingWeeds: number;
  /**
   * custom categories support
   * when using legacy metrics, there will always be one crop and four weed
   * categories (broadleaf, grass, offshoot, purslane). When using Jigsaw
   * metrics, there may be any number of crops and weeds categories. Keyed by
   * bare category UUID; each value's category_source says which system the
   * UUID belongs to. The client resolves UUIDs to display names locally.
   */
  weedMetricsByCategory: { [key: string]: WeedMetrics };
  cropMetricsByCategory: { [key: string]: CropMetrics };
  latestCrop:
    | JigsawCrop
    | undefined;
  /**
   * Weed and crop metrics grouped by the plant profile they were observed
   * under. Ordered by coverage descending.
   * Groups with no categories are omitted. Only set for JIGSAW data.
   */
  plantProfileMetrics: PlantProfileMetrics[];
  /**
   * Grade from avg_weed_size_mm and total_weeds. Set on job and day
   * aggregates. UNSPECIFIED when there are no weeds or the size is at or
   * below zero.
   */
  entryTimingGrade: EntryTimingGrade;
  thinningProfiles: JigsawThinningProfile[];
}

export interface DailyMetricResponse_WeedMetricsByCategoryEntry {
  key: string;
  value: WeedMetrics | undefined;
}

export interface DailyMetricResponse_CropMetricsByCategoryEntry {
  key: string;
  value: CropMetrics | undefined;
}

export interface JigsawBandingProfile {
  id: string;
  name: string;
}

export interface JigsawThinningProfile {
  id: string;
  name: string;
}

export interface JigsawCrop {
  id: string;
  cropType: JigsawCrop_CropType;
  localizedName: string;
}

export enum JigsawCrop_CropType {
  CROP_TYPE_UNSPECIFIED = 0,
  CROP_TYPE_CARBON = 1,
  CROP_TYPE_VESELKA = 2,
  UNRECOGNIZED = -1,
}

export function jigsawCrop_CropTypeFromJSON(object: any): JigsawCrop_CropType {
  switch (object) {
    case 0:
    case "CROP_TYPE_UNSPECIFIED":
      return JigsawCrop_CropType.CROP_TYPE_UNSPECIFIED;
    case 1:
    case "CROP_TYPE_CARBON":
      return JigsawCrop_CropType.CROP_TYPE_CARBON;
    case 2:
    case "CROP_TYPE_VESELKA":
      return JigsawCrop_CropType.CROP_TYPE_VESELKA;
    case -1:
    case "UNRECOGNIZED":
    default:
      return JigsawCrop_CropType.UNRECOGNIZED;
  }
}

export function jigsawCrop_CropTypeToJSON(object: JigsawCrop_CropType): string {
  switch (object) {
    case JigsawCrop_CropType.CROP_TYPE_UNSPECIFIED:
      return "CROP_TYPE_UNSPECIFIED";
    case JigsawCrop_CropType.CROP_TYPE_CARBON:
      return "CROP_TYPE_CARBON";
    case JigsawCrop_CropType.CROP_TYPE_VESELKA:
      return "CROP_TYPE_VESELKA";
    case JigsawCrop_CropType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface JigsawJob {
  id: string;
  name: string;
}

/** metrics[date] */
export interface DailyMetricsByDateResponse {
  metrics: { [key: string]: DailyMetricResponse };
}

export interface DailyMetricsByDateResponse_MetricsEntry {
  key: string;
  value: DailyMetricResponse | undefined;
}

/** metrics[serial].metrics[date] */
export interface DailyMetricsByDateByRobotResponse {
  metrics: { [key: string]: DailyMetricsByDateResponse };
}

export interface DailyMetricsByDateByRobotResponse_MetricsEntry {
  key: string;
  value: DailyMetricsByDateResponse | undefined;
}

/** One row per job (job_metrics + jobs) */
export interface JobMetricResponse {
  /** base */
  db: DB | undefined;
  serial: string;
  /** local calendar date of job start (robot timezone when available) */
  date: string;
  jobId: string;
  jobName: string;
  /** shared certified fields */
  acresWeeded: number;
  avgSpeedMph: number;
  avgWeedSizeMm: number;
  bandingConfigName: string;
  bandingEnabled: boolean;
  coverageSpeedAcresHr: number;
  distanceWeededMeters: number;
  killedWeeds: number;
  missedWeeds: number;
  skippedWeeds: number;
  timeEfficiency: number;
  totalWeeds: number;
  uptimeSeconds: number;
  weedDensitySqFt: number;
  weedingUptimeSeconds: number;
  weedingEfficiency: number;
  /**
   * prefer weeds_type_fraction_*
   *
   * @deprecated
   */
  weedsTypeCountBroadleaf: number;
  /** @deprecated */
  weedsTypeCountGrass: number;
  /** @deprecated */
  weedsTypeCountOffshoot: number;
  /** @deprecated */
  weedsTypeCountPurslane: number;
  keptCrops: number;
  missedCrops: number;
  notThinning: number;
  notWeeding: number;
  skippedCrops: number;
  thinnedCrops: number;
  totalCrops: number;
  bandingPercentage: number;
  thinningEfficiency: number;
  cropId: string;
  crop: string;
  cropDensitySqFt: number;
  avgCropSizeMm: number;
  avgTargetableReqLaserTime: number;
  avgUntargetableReqLaserTime: number;
  validCrops: number;
  operatorEffectiveness: number;
  targetWeedingTimeSeconds: number;
  embeddingsActiveUptimeSeconds: number;
  customerId: string;
  /** job specific */
  jobStartTimestampMs: number;
  /** 0 if not finished */
  jobStopTimestampMs: number;
  jobCompleted: boolean;
  dataSource: MetricDataSource;
  bandingProfiles: JigsawBandingProfile[];
  crops: JigsawCrop[];
  overallEfficiency: number;
  totalWeedsInBand: number;
  /**
   * fraction (0-1) of categorized weeds in each category
   *
   * @deprecated
   */
  weedsTypeFractionBroadleaf: number;
  /** @deprecated */
  weedsTypeFractionGrass: number;
  /** @deprecated */
  weedsTypeFractionOffshoot: number;
  /** @deprecated */
  weedsTypeFractionPurslane: number;
  /**
   * custom categories support
   * replaces weed_type_fraction_* and weeds_type_count_*.
   * Keyed by bare category UUID - each value's category_source says which
   * system the UUID belongs to.
   */
  weedMetricsByCategory: { [key: string]: WeedMetrics };
  /**
   * Observed metric activity. Unset when nothing has been recorded. These do
   * not replace job_start_timestamp_ms / job_stop_timestamp_ms.
   */
  jobFirstSeen: string | undefined;
  jobLastSeen: string | undefined;
  latestCrop:
    | JigsawCrop
    | undefined;
  /**
   * Grade from avg_weed_size_mm and total_weeds. Reports by job read this
   * field. UNSPECIFIED when there are no weeds or the size is at or below
   * zero.
   */
  entryTimingGrade: EntryTimingGrade;
  thinningProfiles: JigsawThinningProfile[];
}

export interface JobMetricResponse_WeedMetricsByCategoryEntry {
  key: string;
  value: WeedMetrics | undefined;
}

/** metrics[job_id] */
export interface JobMetricsByJobResponse {
  metrics: { [key: string]: JobMetricResponse };
}

export interface JobMetricsByJobResponse_MetricsEntry {
  key: string;
  value: JobMetricResponse | undefined;
}

/** metrics[serial].metrics[job_id] */
export interface JobMetricsByJobsByRobotResponse {
  metrics: { [key: string]: JobMetricsByJobResponse };
}

export interface JobMetricsByJobsByRobotResponse_MetricsEntry {
  key: string;
  value: JobMetricsByJobResponse | undefined;
}

function createBaseCropMetrics(): CropMetrics {
  return {
    densityPerSquareMeter: 0,
    averageRadiusMeters: 0,
    found: 0,
    thinned: 0,
    ignored: 0,
    missed: 0,
    kept: 0,
    categorySource: 0,
    localizedName: "",
  };
}

export const CropMetrics: MessageFns<CropMetrics> = {
  encode(message: CropMetrics, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.densityPerSquareMeter !== 0) {
      writer.uint32(13).float(message.densityPerSquareMeter);
    }
    if (message.averageRadiusMeters !== 0) {
      writer.uint32(21).float(message.averageRadiusMeters);
    }
    if (message.found !== 0) {
      writer.uint32(24).int64(message.found);
    }
    if (message.thinned !== 0) {
      writer.uint32(32).int64(message.thinned);
    }
    if (message.ignored !== 0) {
      writer.uint32(56).int64(message.ignored);
    }
    if (message.missed !== 0) {
      writer.uint32(64).int64(message.missed);
    }
    if (message.kept !== 0) {
      writer.uint32(40).int64(message.kept);
    }
    if (message.categorySource !== 0) {
      writer.uint32(48).int32(message.categorySource);
    }
    if (message.localizedName !== "") {
      writer.uint32(74).string(message.localizedName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CropMetrics {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCropMetrics();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.densityPerSquareMeter = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.averageRadiusMeters = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.found = longToNumber(reader.int64());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.thinned = longToNumber(reader.int64());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.ignored = longToNumber(reader.int64());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.missed = longToNumber(reader.int64());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.kept = longToNumber(reader.int64());
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.categorySource = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.localizedName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CropMetrics {
    return {
      densityPerSquareMeter: isSet(object.densityPerSquareMeter)
        ? globalThis.Number(object.densityPerSquareMeter)
        : isSet(object.density_per_square_meter)
        ? globalThis.Number(object.density_per_square_meter)
        : 0,
      averageRadiusMeters: isSet(object.averageRadiusMeters)
        ? globalThis.Number(object.averageRadiusMeters)
        : isSet(object.average_radius_meters)
        ? globalThis.Number(object.average_radius_meters)
        : 0,
      found: isSet(object.found) ? globalThis.Number(object.found) : 0,
      thinned: isSet(object.thinned) ? globalThis.Number(object.thinned) : 0,
      ignored: isSet(object.ignored) ? globalThis.Number(object.ignored) : 0,
      missed: isSet(object.missed) ? globalThis.Number(object.missed) : 0,
      kept: isSet(object.kept) ? globalThis.Number(object.kept) : 0,
      categorySource: isSet(object.categorySource)
        ? categorySourceFromJSON(object.categorySource)
        : isSet(object.category_source)
        ? categorySourceFromJSON(object.category_source)
        : 0,
      localizedName: isSet(object.localizedName)
        ? globalThis.String(object.localizedName)
        : isSet(object.localized_name)
        ? globalThis.String(object.localized_name)
        : "",
    };
  },

  toJSON(message: CropMetrics): unknown {
    const obj: any = {};
    if (message.densityPerSquareMeter !== 0) {
      obj.densityPerSquareMeter = message.densityPerSquareMeter;
    }
    if (message.averageRadiusMeters !== 0) {
      obj.averageRadiusMeters = message.averageRadiusMeters;
    }
    if (message.found !== 0) {
      obj.found = Math.round(message.found);
    }
    if (message.thinned !== 0) {
      obj.thinned = Math.round(message.thinned);
    }
    if (message.ignored !== 0) {
      obj.ignored = Math.round(message.ignored);
    }
    if (message.missed !== 0) {
      obj.missed = Math.round(message.missed);
    }
    if (message.kept !== 0) {
      obj.kept = Math.round(message.kept);
    }
    if (message.categorySource !== 0) {
      obj.categorySource = categorySourceToJSON(message.categorySource);
    }
    if (message.localizedName !== "") {
      obj.localizedName = message.localizedName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CropMetrics>, I>>(base?: I): CropMetrics {
    return CropMetrics.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CropMetrics>, I>>(object: I): CropMetrics {
    const message = createBaseCropMetrics();
    message.densityPerSquareMeter = object.densityPerSquareMeter ?? 0;
    message.averageRadiusMeters = object.averageRadiusMeters ?? 0;
    message.found = object.found ?? 0;
    message.thinned = object.thinned ?? 0;
    message.ignored = object.ignored ?? 0;
    message.missed = object.missed ?? 0;
    message.kept = object.kept ?? 0;
    message.categorySource = object.categorySource ?? 0;
    message.localizedName = object.localizedName ?? "";
    return message;
  },
};

function createBaseWeedMetrics(): WeedMetrics {
  return { fractionOfTotal: 0, categorySource: 0, localizedName: "" };
}

export const WeedMetrics: MessageFns<WeedMetrics> = {
  encode(message: WeedMetrics, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fractionOfTotal !== 0) {
      writer.uint32(13).float(message.fractionOfTotal);
    }
    if (message.categorySource !== 0) {
      writer.uint32(16).int32(message.categorySource);
    }
    if (message.localizedName !== "") {
      writer.uint32(26).string(message.localizedName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WeedMetrics {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWeedMetrics();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.fractionOfTotal = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.categorySource = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.localizedName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WeedMetrics {
    return {
      fractionOfTotal: isSet(object.fractionOfTotal)
        ? globalThis.Number(object.fractionOfTotal)
        : isSet(object.fraction_of_total)
        ? globalThis.Number(object.fraction_of_total)
        : 0,
      categorySource: isSet(object.categorySource)
        ? categorySourceFromJSON(object.categorySource)
        : isSet(object.category_source)
        ? categorySourceFromJSON(object.category_source)
        : 0,
      localizedName: isSet(object.localizedName)
        ? globalThis.String(object.localizedName)
        : isSet(object.localized_name)
        ? globalThis.String(object.localized_name)
        : "",
    };
  },

  toJSON(message: WeedMetrics): unknown {
    const obj: any = {};
    if (message.fractionOfTotal !== 0) {
      obj.fractionOfTotal = message.fractionOfTotal;
    }
    if (message.categorySource !== 0) {
      obj.categorySource = categorySourceToJSON(message.categorySource);
    }
    if (message.localizedName !== "") {
      obj.localizedName = message.localizedName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WeedMetrics>, I>>(base?: I): WeedMetrics {
    return WeedMetrics.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WeedMetrics>, I>>(object: I): WeedMetrics {
    const message = createBaseWeedMetrics();
    message.fractionOfTotal = object.fractionOfTotal ?? 0;
    message.categorySource = object.categorySource ?? 0;
    message.localizedName = object.localizedName ?? "";
    return message;
  },
};

function createBasePlantProfileMetrics(): PlantProfileMetrics {
  return {
    profileId: "",
    unattributed: false,
    weedDensityPerSquareMeter: 0,
    averageWeedRadiusMeters: 0,
    totalWeeds: 0,
    totalWeedsInBand: 0,
    killedWeeds: 0,
    missedWeeds: 0,
    skippedWeeds: 0,
    weedMetricsByCategory: {},
    cropMetricsByCategory: {},
    profileName: "",
    entryTimingGrade: 0,
  };
}

export const PlantProfileMetrics: MessageFns<PlantProfileMetrics> = {
  encode(message: PlantProfileMetrics, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.profileId !== "") {
      writer.uint32(10).string(message.profileId);
    }
    if (message.unattributed !== false) {
      writer.uint32(16).bool(message.unattributed);
    }
    if (message.weedDensityPerSquareMeter !== 0) {
      writer.uint32(29).float(message.weedDensityPerSquareMeter);
    }
    if (message.averageWeedRadiusMeters !== 0) {
      writer.uint32(37).float(message.averageWeedRadiusMeters);
    }
    if (message.totalWeeds !== 0) {
      writer.uint32(40).int64(message.totalWeeds);
    }
    if (message.totalWeedsInBand !== 0) {
      writer.uint32(48).int64(message.totalWeedsInBand);
    }
    if (message.killedWeeds !== 0) {
      writer.uint32(56).int64(message.killedWeeds);
    }
    if (message.missedWeeds !== 0) {
      writer.uint32(64).int64(message.missedWeeds);
    }
    if (message.skippedWeeds !== 0) {
      writer.uint32(72).int64(message.skippedWeeds);
    }
    globalThis.Object.entries(message.weedMetricsByCategory).forEach(([key, value]: [string, WeedMetrics]) => {
      PlantProfileMetrics_WeedMetricsByCategoryEntry.encode({ key: key as any, value }, writer.uint32(82).fork())
        .join();
    });
    globalThis.Object.entries(message.cropMetricsByCategory).forEach(([key, value]: [string, CropMetrics]) => {
      PlantProfileMetrics_CropMetricsByCategoryEntry.encode({ key: key as any, value }, writer.uint32(90).fork())
        .join();
    });
    if (message.profileName !== "") {
      writer.uint32(98).string(message.profileName);
    }
    if (message.entryTimingGrade !== 0) {
      writer.uint32(104).int32(message.entryTimingGrade);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlantProfileMetrics {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlantProfileMetrics();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.profileId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.unattributed = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.weedDensityPerSquareMeter = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.averageWeedRadiusMeters = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.totalWeeds = longToNumber(reader.int64());
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.totalWeedsInBand = longToNumber(reader.int64());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.killedWeeds = longToNumber(reader.int64());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.missedWeeds = longToNumber(reader.int64());
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.skippedWeeds = longToNumber(reader.int64());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          const entry10 = PlantProfileMetrics_WeedMetricsByCategoryEntry.decode(reader, reader.uint32());
          if (entry10.value !== undefined) {
            message.weedMetricsByCategory[entry10.key] = entry10.value;
          }
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          const entry11 = PlantProfileMetrics_CropMetricsByCategoryEntry.decode(reader, reader.uint32());
          if (entry11.value !== undefined) {
            message.cropMetricsByCategory[entry11.key] = entry11.value;
          }
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.profileName = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.entryTimingGrade = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlantProfileMetrics {
    return {
      profileId: isSet(object.profileId)
        ? globalThis.String(object.profileId)
        : isSet(object.profile_id)
        ? globalThis.String(object.profile_id)
        : "",
      unattributed: isSet(object.unattributed) ? globalThis.Boolean(object.unattributed) : false,
      weedDensityPerSquareMeter: isSet(object.weedDensityPerSquareMeter)
        ? globalThis.Number(object.weedDensityPerSquareMeter)
        : isSet(object.weed_density_per_square_meter)
        ? globalThis.Number(object.weed_density_per_square_meter)
        : 0,
      averageWeedRadiusMeters: isSet(object.averageWeedRadiusMeters)
        ? globalThis.Number(object.averageWeedRadiusMeters)
        : isSet(object.average_weed_radius_meters)
        ? globalThis.Number(object.average_weed_radius_meters)
        : 0,
      totalWeeds: isSet(object.totalWeeds)
        ? globalThis.Number(object.totalWeeds)
        : isSet(object.total_weeds)
        ? globalThis.Number(object.total_weeds)
        : 0,
      totalWeedsInBand: isSet(object.totalWeedsInBand)
        ? globalThis.Number(object.totalWeedsInBand)
        : isSet(object.total_weeds_in_band)
        ? globalThis.Number(object.total_weeds_in_band)
        : 0,
      killedWeeds: isSet(object.killedWeeds)
        ? globalThis.Number(object.killedWeeds)
        : isSet(object.killed_weeds)
        ? globalThis.Number(object.killed_weeds)
        : 0,
      missedWeeds: isSet(object.missedWeeds)
        ? globalThis.Number(object.missedWeeds)
        : isSet(object.missed_weeds)
        ? globalThis.Number(object.missed_weeds)
        : 0,
      skippedWeeds: isSet(object.skippedWeeds)
        ? globalThis.Number(object.skippedWeeds)
        : isSet(object.skipped_weeds)
        ? globalThis.Number(object.skipped_weeds)
        : 0,
      weedMetricsByCategory: isObject(object.weedMetricsByCategory)
        ? (globalThis.Object.entries(object.weedMetricsByCategory) as [string, any][]).reduce(
          (acc: { [key: string]: WeedMetrics }, [key, value]: [string, any]) => {
            acc[key] = WeedMetrics.fromJSON(value);
            return acc;
          },
          {},
        )
        : isObject(object.weed_metrics_by_category)
        ? (globalThis.Object.entries(object.weed_metrics_by_category) as [string, any][]).reduce(
          (acc: { [key: string]: WeedMetrics }, [key, value]: [string, any]) => {
            acc[key] = WeedMetrics.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
      cropMetricsByCategory: isObject(object.cropMetricsByCategory)
        ? (globalThis.Object.entries(object.cropMetricsByCategory) as [string, any][]).reduce(
          (acc: { [key: string]: CropMetrics }, [key, value]: [string, any]) => {
            acc[key] = CropMetrics.fromJSON(value);
            return acc;
          },
          {},
        )
        : isObject(object.crop_metrics_by_category)
        ? (globalThis.Object.entries(object.crop_metrics_by_category) as [string, any][]).reduce(
          (acc: { [key: string]: CropMetrics }, [key, value]: [string, any]) => {
            acc[key] = CropMetrics.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
      profileName: isSet(object.profileName)
        ? globalThis.String(object.profileName)
        : isSet(object.profile_name)
        ? globalThis.String(object.profile_name)
        : "",
      entryTimingGrade: isSet(object.entryTimingGrade)
        ? entryTimingGradeFromJSON(object.entryTimingGrade)
        : isSet(object.entry_timing_grade)
        ? entryTimingGradeFromJSON(object.entry_timing_grade)
        : 0,
    };
  },

  toJSON(message: PlantProfileMetrics): unknown {
    const obj: any = {};
    if (message.profileId !== "") {
      obj.profileId = message.profileId;
    }
    if (message.unattributed !== false) {
      obj.unattributed = message.unattributed;
    }
    if (message.weedDensityPerSquareMeter !== 0) {
      obj.weedDensityPerSquareMeter = message.weedDensityPerSquareMeter;
    }
    if (message.averageWeedRadiusMeters !== 0) {
      obj.averageWeedRadiusMeters = message.averageWeedRadiusMeters;
    }
    if (message.totalWeeds !== 0) {
      obj.totalWeeds = Math.round(message.totalWeeds);
    }
    if (message.totalWeedsInBand !== 0) {
      obj.totalWeedsInBand = Math.round(message.totalWeedsInBand);
    }
    if (message.killedWeeds !== 0) {
      obj.killedWeeds = Math.round(message.killedWeeds);
    }
    if (message.missedWeeds !== 0) {
      obj.missedWeeds = Math.round(message.missedWeeds);
    }
    if (message.skippedWeeds !== 0) {
      obj.skippedWeeds = Math.round(message.skippedWeeds);
    }
    if (message.weedMetricsByCategory) {
      const entries = globalThis.Object.entries(message.weedMetricsByCategory) as [string, WeedMetrics][];
      if (entries.length > 0) {
        obj.weedMetricsByCategory = {};
        entries.forEach(([k, v]) => {
          obj.weedMetricsByCategory[k] = WeedMetrics.toJSON(v);
        });
      }
    }
    if (message.cropMetricsByCategory) {
      const entries = globalThis.Object.entries(message.cropMetricsByCategory) as [string, CropMetrics][];
      if (entries.length > 0) {
        obj.cropMetricsByCategory = {};
        entries.forEach(([k, v]) => {
          obj.cropMetricsByCategory[k] = CropMetrics.toJSON(v);
        });
      }
    }
    if (message.profileName !== "") {
      obj.profileName = message.profileName;
    }
    if (message.entryTimingGrade !== 0) {
      obj.entryTimingGrade = entryTimingGradeToJSON(message.entryTimingGrade);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlantProfileMetrics>, I>>(base?: I): PlantProfileMetrics {
    return PlantProfileMetrics.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlantProfileMetrics>, I>>(object: I): PlantProfileMetrics {
    const message = createBasePlantProfileMetrics();
    message.profileId = object.profileId ?? "";
    message.unattributed = object.unattributed ?? false;
    message.weedDensityPerSquareMeter = object.weedDensityPerSquareMeter ?? 0;
    message.averageWeedRadiusMeters = object.averageWeedRadiusMeters ?? 0;
    message.totalWeeds = object.totalWeeds ?? 0;
    message.totalWeedsInBand = object.totalWeedsInBand ?? 0;
    message.killedWeeds = object.killedWeeds ?? 0;
    message.missedWeeds = object.missedWeeds ?? 0;
    message.skippedWeeds = object.skippedWeeds ?? 0;
    message.weedMetricsByCategory =
      (globalThis.Object.entries(object.weedMetricsByCategory ?? {}) as [string, WeedMetrics][]).reduce(
        (acc: { [key: string]: WeedMetrics }, [key, value]: [string, WeedMetrics]) => {
          if (value !== undefined) {
            acc[key] = WeedMetrics.fromPartial(value);
          }
          return acc;
        },
        {},
      );
    message.cropMetricsByCategory =
      (globalThis.Object.entries(object.cropMetricsByCategory ?? {}) as [string, CropMetrics][]).reduce(
        (acc: { [key: string]: CropMetrics }, [key, value]: [string, CropMetrics]) => {
          if (value !== undefined) {
            acc[key] = CropMetrics.fromPartial(value);
          }
          return acc;
        },
        {},
      );
    message.profileName = object.profileName ?? "";
    message.entryTimingGrade = object.entryTimingGrade ?? 0;
    return message;
  },
};

function createBasePlantProfileMetrics_WeedMetricsByCategoryEntry(): PlantProfileMetrics_WeedMetricsByCategoryEntry {
  return { key: "", value: undefined };
}

export const PlantProfileMetrics_WeedMetricsByCategoryEntry: MessageFns<
  PlantProfileMetrics_WeedMetricsByCategoryEntry
> = {
  encode(
    message: PlantProfileMetrics_WeedMetricsByCategoryEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      WeedMetrics.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlantProfileMetrics_WeedMetricsByCategoryEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlantProfileMetrics_WeedMetricsByCategoryEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = WeedMetrics.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlantProfileMetrics_WeedMetricsByCategoryEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? WeedMetrics.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: PlantProfileMetrics_WeedMetricsByCategoryEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = WeedMetrics.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlantProfileMetrics_WeedMetricsByCategoryEntry>, I>>(
    base?: I,
  ): PlantProfileMetrics_WeedMetricsByCategoryEntry {
    return PlantProfileMetrics_WeedMetricsByCategoryEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlantProfileMetrics_WeedMetricsByCategoryEntry>, I>>(
    object: I,
  ): PlantProfileMetrics_WeedMetricsByCategoryEntry {
    const message = createBasePlantProfileMetrics_WeedMetricsByCategoryEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? WeedMetrics.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBasePlantProfileMetrics_CropMetricsByCategoryEntry(): PlantProfileMetrics_CropMetricsByCategoryEntry {
  return { key: "", value: undefined };
}

export const PlantProfileMetrics_CropMetricsByCategoryEntry: MessageFns<
  PlantProfileMetrics_CropMetricsByCategoryEntry
> = {
  encode(
    message: PlantProfileMetrics_CropMetricsByCategoryEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      CropMetrics.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlantProfileMetrics_CropMetricsByCategoryEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlantProfileMetrics_CropMetricsByCategoryEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = CropMetrics.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlantProfileMetrics_CropMetricsByCategoryEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? CropMetrics.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: PlantProfileMetrics_CropMetricsByCategoryEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = CropMetrics.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlantProfileMetrics_CropMetricsByCategoryEntry>, I>>(
    base?: I,
  ): PlantProfileMetrics_CropMetricsByCategoryEntry {
    return PlantProfileMetrics_CropMetricsByCategoryEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlantProfileMetrics_CropMetricsByCategoryEntry>, I>>(
    object: I,
  ): PlantProfileMetrics_CropMetricsByCategoryEntry {
    const message = createBasePlantProfileMetrics_CropMetricsByCategoryEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? CropMetrics.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseDailyMetricResponse(): DailyMetricResponse {
  return {
    db: undefined,
    serial: "",
    robotId: 0,
    date: "",
    jobId: "",
    jobName: "",
    acresWeeded: 0,
    avgSpeedMph: 0,
    avgWeedSizeMm: 0,
    bandingConfigName: "",
    bandingEnabled: false,
    coverageSpeedAcresHr: 0,
    distanceWeededMeters: 0,
    killedWeeds: 0,
    missedWeeds: 0,
    skippedWeeds: 0,
    timeEfficiency: 0,
    totalWeeds: 0,
    uptimeSeconds: 0,
    weedDensitySqFt: 0,
    weedingUptimeSeconds: 0,
    weedingEfficiency: 0,
    weedsTypeCountBroadleaf: 0,
    weedsTypeCountGrass: 0,
    weedsTypeCountOffshoot: 0,
    weedsTypeCountPurslane: 0,
    keptCrops: 0,
    missedCrops: 0,
    notThinning: 0,
    notWeeding: 0,
    skippedCrops: 0,
    thinnedCrops: 0,
    totalCrops: 0,
    bandingPercentage: 0,
    thinningEfficiency: 0,
    cropId: "",
    crop: "",
    cropDensitySqFt: 0,
    avgCropSizeMm: 0,
    avgTargetableReqLaserTime: 0,
    avgUntargetableReqLaserTime: 0,
    validCrops: 0,
    operatorEffectiveness: 0,
    targetWeedingTimeSeconds: 0,
    embeddingsActiveUptimeSeconds: 0,
    customerId: "",
    dataSource: 0,
    bandingProfiles: [],
    crops: [],
    jobs: [],
    overallEfficiency: 0,
    totalWeedsInBand: 0,
    weedsTypeFractionBroadleaf: 0,
    weedsTypeFractionGrass: 0,
    weedsTypeFractionOffshoot: 0,
    weedsTypeFractionPurslane: 0,
    notWeedingWeeds: 0,
    weedMetricsByCategory: {},
    cropMetricsByCategory: {},
    latestCrop: undefined,
    plantProfileMetrics: [],
    entryTimingGrade: 0,
    thinningProfiles: [],
  };
}

export const DailyMetricResponse: MessageFns<DailyMetricResponse> = {
  encode(message: DailyMetricResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.db !== undefined) {
      DB.encode(message.db, writer.uint32(10).fork()).join();
    }
    if (message.serial !== "") {
      writer.uint32(18).string(message.serial);
    }
    if (message.robotId !== 0) {
      writer.uint32(24).uint64(message.robotId);
    }
    if (message.date !== "") {
      writer.uint32(202).string(message.date);
    }
    if (message.jobId !== "") {
      writer.uint32(354).string(message.jobId);
    }
    if (message.jobName !== "") {
      writer.uint32(362).string(message.jobName);
    }
    if (message.acresWeeded !== 0) {
      writer.uint32(37).float(message.acresWeeded);
    }
    if (message.avgSpeedMph !== 0) {
      writer.uint32(45).float(message.avgSpeedMph);
    }
    if (message.avgWeedSizeMm !== 0) {
      writer.uint32(53).float(message.avgWeedSizeMm);
    }
    if (message.bandingConfigName !== "") {
      writer.uint32(58).string(message.bandingConfigName);
    }
    if (message.bandingEnabled !== false) {
      writer.uint32(64).bool(message.bandingEnabled);
    }
    if (message.coverageSpeedAcresHr !== 0) {
      writer.uint32(77).float(message.coverageSpeedAcresHr);
    }
    if (message.distanceWeededMeters !== 0) {
      writer.uint32(85).float(message.distanceWeededMeters);
    }
    if (message.killedWeeds !== 0) {
      writer.uint32(88).int64(message.killedWeeds);
    }
    if (message.missedWeeds !== 0) {
      writer.uint32(96).int64(message.missedWeeds);
    }
    if (message.skippedWeeds !== 0) {
      writer.uint32(104).int64(message.skippedWeeds);
    }
    if (message.timeEfficiency !== 0) {
      writer.uint32(117).float(message.timeEfficiency);
    }
    if (message.totalWeeds !== 0) {
      writer.uint32(120).int64(message.totalWeeds);
    }
    if (message.uptimeSeconds !== 0) {
      writer.uint32(133).float(message.uptimeSeconds);
    }
    if (message.weedDensitySqFt !== 0) {
      writer.uint32(141).float(message.weedDensitySqFt);
    }
    if (message.weedingUptimeSeconds !== 0) {
      writer.uint32(149).float(message.weedingUptimeSeconds);
    }
    if (message.weedingEfficiency !== 0) {
      writer.uint32(157).float(message.weedingEfficiency);
    }
    if (message.weedsTypeCountBroadleaf !== 0) {
      writer.uint32(160).int64(message.weedsTypeCountBroadleaf);
    }
    if (message.weedsTypeCountGrass !== 0) {
      writer.uint32(168).int64(message.weedsTypeCountGrass);
    }
    if (message.weedsTypeCountOffshoot !== 0) {
      writer.uint32(176).int64(message.weedsTypeCountOffshoot);
    }
    if (message.weedsTypeCountPurslane !== 0) {
      writer.uint32(184).int64(message.weedsTypeCountPurslane);
    }
    if (message.keptCrops !== 0) {
      writer.uint32(208).int64(message.keptCrops);
    }
    if (message.missedCrops !== 0) {
      writer.uint32(216).int64(message.missedCrops);
    }
    if (message.notThinning !== 0) {
      writer.uint32(224).int64(message.notThinning);
    }
    if (message.notWeeding !== 0) {
      writer.uint32(232).int64(message.notWeeding);
    }
    if (message.skippedCrops !== 0) {
      writer.uint32(240).int64(message.skippedCrops);
    }
    if (message.thinnedCrops !== 0) {
      writer.uint32(248).int64(message.thinnedCrops);
    }
    if (message.totalCrops !== 0) {
      writer.uint32(256).int64(message.totalCrops);
    }
    if (message.bandingPercentage !== 0) {
      writer.uint32(269).float(message.bandingPercentage);
    }
    if (message.thinningEfficiency !== 0) {
      writer.uint32(277).float(message.thinningEfficiency);
    }
    if (message.cropId !== "") {
      writer.uint32(282).string(message.cropId);
    }
    if (message.crop !== "") {
      writer.uint32(290).string(message.crop);
    }
    if (message.cropDensitySqFt !== 0) {
      writer.uint32(301).float(message.cropDensitySqFt);
    }
    if (message.avgCropSizeMm !== 0) {
      writer.uint32(309).float(message.avgCropSizeMm);
    }
    if (message.avgTargetableReqLaserTime !== 0) {
      writer.uint32(312).int64(message.avgTargetableReqLaserTime);
    }
    if (message.avgUntargetableReqLaserTime !== 0) {
      writer.uint32(320).int64(message.avgUntargetableReqLaserTime);
    }
    if (message.validCrops !== 0) {
      writer.uint32(328).int64(message.validCrops);
    }
    if (message.operatorEffectiveness !== 0) {
      writer.uint32(341).float(message.operatorEffectiveness);
    }
    if (message.targetWeedingTimeSeconds !== 0) {
      writer.uint32(344).int64(message.targetWeedingTimeSeconds);
    }
    if (message.embeddingsActiveUptimeSeconds !== 0) {
      writer.uint32(373).float(message.embeddingsActiveUptimeSeconds);
    }
    if (message.customerId !== "") {
      writer.uint32(378).string(message.customerId);
    }
    if (message.dataSource !== 0) {
      writer.uint32(384).int32(message.dataSource);
    }
    for (const v of message.bandingProfiles) {
      JigsawBandingProfile.encode(v!, writer.uint32(394).fork()).join();
    }
    for (const v of message.crops) {
      JigsawCrop.encode(v!, writer.uint32(402).fork()).join();
    }
    for (const v of message.jobs) {
      JigsawJob.encode(v!, writer.uint32(410).fork()).join();
    }
    if (message.overallEfficiency !== 0) {
      writer.uint32(421).float(message.overallEfficiency);
    }
    if (message.totalWeedsInBand !== 0) {
      writer.uint32(429).float(message.totalWeedsInBand);
    }
    if (message.weedsTypeFractionBroadleaf !== 0) {
      writer.uint32(437).float(message.weedsTypeFractionBroadleaf);
    }
    if (message.weedsTypeFractionGrass !== 0) {
      writer.uint32(445).float(message.weedsTypeFractionGrass);
    }
    if (message.weedsTypeFractionOffshoot !== 0) {
      writer.uint32(453).float(message.weedsTypeFractionOffshoot);
    }
    if (message.weedsTypeFractionPurslane !== 0) {
      writer.uint32(461).float(message.weedsTypeFractionPurslane);
    }
    if (message.notWeedingWeeds !== 0) {
      writer.uint32(192).int64(message.notWeedingWeeds);
    }
    globalThis.Object.entries(message.weedMetricsByCategory).forEach(([key, value]: [string, WeedMetrics]) => {
      DailyMetricResponse_WeedMetricsByCategoryEntry.encode({ key: key as any, value }, writer.uint32(466).fork())
        .join();
    });
    globalThis.Object.entries(message.cropMetricsByCategory).forEach(([key, value]: [string, CropMetrics]) => {
      DailyMetricResponse_CropMetricsByCategoryEntry.encode({ key: key as any, value }, writer.uint32(474).fork())
        .join();
    });
    if (message.latestCrop !== undefined) {
      JigsawCrop.encode(message.latestCrop, writer.uint32(514).fork()).join();
    }
    for (const v of message.plantProfileMetrics) {
      PlantProfileMetrics.encode(v!, writer.uint32(522).fork()).join();
    }
    if (message.entryTimingGrade !== 0) {
      writer.uint32(528).int32(message.entryTimingGrade);
    }
    for (const v of message.thinningProfiles) {
      JigsawThinningProfile.encode(v!, writer.uint32(538).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DailyMetricResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDailyMetricResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.db = DB.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.serial = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.robotId = longToNumber(reader.uint64());
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.date = reader.string();
          continue;
        }
        case 44: {
          if (tag !== 354) {
            break;
          }

          message.jobId = reader.string();
          continue;
        }
        case 45: {
          if (tag !== 362) {
            break;
          }

          message.jobName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.acresWeeded = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.avgSpeedMph = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.avgWeedSizeMm = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.bandingConfigName = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.bandingEnabled = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 77) {
            break;
          }

          message.coverageSpeedAcresHr = reader.float();
          continue;
        }
        case 10: {
          if (tag !== 85) {
            break;
          }

          message.distanceWeededMeters = reader.float();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.killedWeeds = longToNumber(reader.int64());
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.missedWeeds = longToNumber(reader.int64());
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.skippedWeeds = longToNumber(reader.int64());
          continue;
        }
        case 14: {
          if (tag !== 117) {
            break;
          }

          message.timeEfficiency = reader.float();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.totalWeeds = longToNumber(reader.int64());
          continue;
        }
        case 16: {
          if (tag !== 133) {
            break;
          }

          message.uptimeSeconds = reader.float();
          continue;
        }
        case 17: {
          if (tag !== 141) {
            break;
          }

          message.weedDensitySqFt = reader.float();
          continue;
        }
        case 18: {
          if (tag !== 149) {
            break;
          }

          message.weedingUptimeSeconds = reader.float();
          continue;
        }
        case 19: {
          if (tag !== 157) {
            break;
          }

          message.weedingEfficiency = reader.float();
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.weedsTypeCountBroadleaf = longToNumber(reader.int64());
          continue;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.weedsTypeCountGrass = longToNumber(reader.int64());
          continue;
        }
        case 22: {
          if (tag !== 176) {
            break;
          }

          message.weedsTypeCountOffshoot = longToNumber(reader.int64());
          continue;
        }
        case 23: {
          if (tag !== 184) {
            break;
          }

          message.weedsTypeCountPurslane = longToNumber(reader.int64());
          continue;
        }
        case 26: {
          if (tag !== 208) {
            break;
          }

          message.keptCrops = longToNumber(reader.int64());
          continue;
        }
        case 27: {
          if (tag !== 216) {
            break;
          }

          message.missedCrops = longToNumber(reader.int64());
          continue;
        }
        case 28: {
          if (tag !== 224) {
            break;
          }

          message.notThinning = longToNumber(reader.int64());
          continue;
        }
        case 29: {
          if (tag !== 232) {
            break;
          }

          message.notWeeding = longToNumber(reader.int64());
          continue;
        }
        case 30: {
          if (tag !== 240) {
            break;
          }

          message.skippedCrops = longToNumber(reader.int64());
          continue;
        }
        case 31: {
          if (tag !== 248) {
            break;
          }

          message.thinnedCrops = longToNumber(reader.int64());
          continue;
        }
        case 32: {
          if (tag !== 256) {
            break;
          }

          message.totalCrops = longToNumber(reader.int64());
          continue;
        }
        case 33: {
          if (tag !== 269) {
            break;
          }

          message.bandingPercentage = reader.float();
          continue;
        }
        case 34: {
          if (tag !== 277) {
            break;
          }

          message.thinningEfficiency = reader.float();
          continue;
        }
        case 35: {
          if (tag !== 282) {
            break;
          }

          message.cropId = reader.string();
          continue;
        }
        case 36: {
          if (tag !== 290) {
            break;
          }

          message.crop = reader.string();
          continue;
        }
        case 37: {
          if (tag !== 301) {
            break;
          }

          message.cropDensitySqFt = reader.float();
          continue;
        }
        case 38: {
          if (tag !== 309) {
            break;
          }

          message.avgCropSizeMm = reader.float();
          continue;
        }
        case 39: {
          if (tag !== 312) {
            break;
          }

          message.avgTargetableReqLaserTime = longToNumber(reader.int64());
          continue;
        }
        case 40: {
          if (tag !== 320) {
            break;
          }

          message.avgUntargetableReqLaserTime = longToNumber(reader.int64());
          continue;
        }
        case 41: {
          if (tag !== 328) {
            break;
          }

          message.validCrops = longToNumber(reader.int64());
          continue;
        }
        case 42: {
          if (tag !== 341) {
            break;
          }

          message.operatorEffectiveness = reader.float();
          continue;
        }
        case 43: {
          if (tag !== 344) {
            break;
          }

          message.targetWeedingTimeSeconds = longToNumber(reader.int64());
          continue;
        }
        case 46: {
          if (tag !== 373) {
            break;
          }

          message.embeddingsActiveUptimeSeconds = reader.float();
          continue;
        }
        case 47: {
          if (tag !== 378) {
            break;
          }

          message.customerId = reader.string();
          continue;
        }
        case 48: {
          if (tag !== 384) {
            break;
          }

          message.dataSource = reader.int32() as any;
          continue;
        }
        case 49: {
          if (tag !== 394) {
            break;
          }

          message.bandingProfiles.push(JigsawBandingProfile.decode(reader, reader.uint32()));
          continue;
        }
        case 50: {
          if (tag !== 402) {
            break;
          }

          message.crops.push(JigsawCrop.decode(reader, reader.uint32()));
          continue;
        }
        case 51: {
          if (tag !== 410) {
            break;
          }

          message.jobs.push(JigsawJob.decode(reader, reader.uint32()));
          continue;
        }
        case 52: {
          if (tag !== 421) {
            break;
          }

          message.overallEfficiency = reader.float();
          continue;
        }
        case 53: {
          if (tag !== 429) {
            break;
          }

          message.totalWeedsInBand = reader.float();
          continue;
        }
        case 54: {
          if (tag !== 437) {
            break;
          }

          message.weedsTypeFractionBroadleaf = reader.float();
          continue;
        }
        case 55: {
          if (tag !== 445) {
            break;
          }

          message.weedsTypeFractionGrass = reader.float();
          continue;
        }
        case 56: {
          if (tag !== 453) {
            break;
          }

          message.weedsTypeFractionOffshoot = reader.float();
          continue;
        }
        case 57: {
          if (tag !== 461) {
            break;
          }

          message.weedsTypeFractionPurslane = reader.float();
          continue;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.notWeedingWeeds = longToNumber(reader.int64());
          continue;
        }
        case 58: {
          if (tag !== 466) {
            break;
          }

          const entry58 = DailyMetricResponse_WeedMetricsByCategoryEntry.decode(reader, reader.uint32());
          if (entry58.value !== undefined) {
            message.weedMetricsByCategory[entry58.key] = entry58.value;
          }
          continue;
        }
        case 59: {
          if (tag !== 474) {
            break;
          }

          const entry59 = DailyMetricResponse_CropMetricsByCategoryEntry.decode(reader, reader.uint32());
          if (entry59.value !== undefined) {
            message.cropMetricsByCategory[entry59.key] = entry59.value;
          }
          continue;
        }
        case 64: {
          if (tag !== 514) {
            break;
          }

          message.latestCrop = JigsawCrop.decode(reader, reader.uint32());
          continue;
        }
        case 65: {
          if (tag !== 522) {
            break;
          }

          message.plantProfileMetrics.push(PlantProfileMetrics.decode(reader, reader.uint32()));
          continue;
        }
        case 66: {
          if (tag !== 528) {
            break;
          }

          message.entryTimingGrade = reader.int32() as any;
          continue;
        }
        case 67: {
          if (tag !== 538) {
            break;
          }

          message.thinningProfiles.push(JigsawThinningProfile.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DailyMetricResponse {
    return {
      db: isSet(object.db) ? DB.fromJSON(object.db) : undefined,
      serial: isSet(object.serial) ? globalThis.String(object.serial) : "",
      robotId: isSet(object.robotId)
        ? globalThis.Number(object.robotId)
        : isSet(object.robot_id)
        ? globalThis.Number(object.robot_id)
        : 0,
      date: isSet(object.date) ? globalThis.String(object.date) : "",
      jobId: isSet(object.jobId)
        ? globalThis.String(object.jobId)
        : isSet(object.job_id)
        ? globalThis.String(object.job_id)
        : "",
      jobName: isSet(object.jobName)
        ? globalThis.String(object.jobName)
        : isSet(object.job_name)
        ? globalThis.String(object.job_name)
        : "",
      acresWeeded: isSet(object.acresWeeded)
        ? globalThis.Number(object.acresWeeded)
        : isSet(object.acres_weeded)
        ? globalThis.Number(object.acres_weeded)
        : 0,
      avgSpeedMph: isSet(object.avgSpeedMph)
        ? globalThis.Number(object.avgSpeedMph)
        : isSet(object.avg_speed_mph)
        ? globalThis.Number(object.avg_speed_mph)
        : 0,
      avgWeedSizeMm: isSet(object.avgWeedSizeMm)
        ? globalThis.Number(object.avgWeedSizeMm)
        : isSet(object.avg_weed_size_mm)
        ? globalThis.Number(object.avg_weed_size_mm)
        : 0,
      bandingConfigName: isSet(object.bandingConfigName)
        ? globalThis.String(object.bandingConfigName)
        : isSet(object.banding_config_name)
        ? globalThis.String(object.banding_config_name)
        : "",
      bandingEnabled: isSet(object.bandingEnabled)
        ? globalThis.Boolean(object.bandingEnabled)
        : isSet(object.banding_enabled)
        ? globalThis.Boolean(object.banding_enabled)
        : false,
      coverageSpeedAcresHr: isSet(object.coverageSpeedAcresHr)
        ? globalThis.Number(object.coverageSpeedAcresHr)
        : isSet(object.coverage_speed_acres_hr)
        ? globalThis.Number(object.coverage_speed_acres_hr)
        : 0,
      distanceWeededMeters: isSet(object.distanceWeededMeters)
        ? globalThis.Number(object.distanceWeededMeters)
        : isSet(object.distance_weeded_meters)
        ? globalThis.Number(object.distance_weeded_meters)
        : 0,
      killedWeeds: isSet(object.killedWeeds)
        ? globalThis.Number(object.killedWeeds)
        : isSet(object.killed_weeds)
        ? globalThis.Number(object.killed_weeds)
        : 0,
      missedWeeds: isSet(object.missedWeeds)
        ? globalThis.Number(object.missedWeeds)
        : isSet(object.missed_weeds)
        ? globalThis.Number(object.missed_weeds)
        : 0,
      skippedWeeds: isSet(object.skippedWeeds)
        ? globalThis.Number(object.skippedWeeds)
        : isSet(object.skipped_weeds)
        ? globalThis.Number(object.skipped_weeds)
        : 0,
      timeEfficiency: isSet(object.timeEfficiency)
        ? globalThis.Number(object.timeEfficiency)
        : isSet(object.time_efficiency)
        ? globalThis.Number(object.time_efficiency)
        : 0,
      totalWeeds: isSet(object.totalWeeds)
        ? globalThis.Number(object.totalWeeds)
        : isSet(object.total_weeds)
        ? globalThis.Number(object.total_weeds)
        : 0,
      uptimeSeconds: isSet(object.uptimeSeconds)
        ? globalThis.Number(object.uptimeSeconds)
        : isSet(object.uptime_seconds)
        ? globalThis.Number(object.uptime_seconds)
        : 0,
      weedDensitySqFt: isSet(object.weedDensitySqFt)
        ? globalThis.Number(object.weedDensitySqFt)
        : isSet(object.weed_density_sq_ft)
        ? globalThis.Number(object.weed_density_sq_ft)
        : 0,
      weedingUptimeSeconds: isSet(object.weedingUptimeSeconds)
        ? globalThis.Number(object.weedingUptimeSeconds)
        : isSet(object.weeding_uptime_seconds)
        ? globalThis.Number(object.weeding_uptime_seconds)
        : 0,
      weedingEfficiency: isSet(object.weedingEfficiency)
        ? globalThis.Number(object.weedingEfficiency)
        : isSet(object.weeding_efficiency)
        ? globalThis.Number(object.weeding_efficiency)
        : 0,
      weedsTypeCountBroadleaf: isSet(object.weedsTypeCountBroadleaf)
        ? globalThis.Number(object.weedsTypeCountBroadleaf)
        : isSet(object.weeds_type_count_broadleaf)
        ? globalThis.Number(object.weeds_type_count_broadleaf)
        : 0,
      weedsTypeCountGrass: isSet(object.weedsTypeCountGrass)
        ? globalThis.Number(object.weedsTypeCountGrass)
        : isSet(object.weeds_type_count_grass)
        ? globalThis.Number(object.weeds_type_count_grass)
        : 0,
      weedsTypeCountOffshoot: isSet(object.weedsTypeCountOffshoot)
        ? globalThis.Number(object.weedsTypeCountOffshoot)
        : isSet(object.weeds_type_count_offshoot)
        ? globalThis.Number(object.weeds_type_count_offshoot)
        : 0,
      weedsTypeCountPurslane: isSet(object.weedsTypeCountPurslane)
        ? globalThis.Number(object.weedsTypeCountPurslane)
        : isSet(object.weeds_type_count_purslane)
        ? globalThis.Number(object.weeds_type_count_purslane)
        : 0,
      keptCrops: isSet(object.keptCrops)
        ? globalThis.Number(object.keptCrops)
        : isSet(object.kept_crops)
        ? globalThis.Number(object.kept_crops)
        : 0,
      missedCrops: isSet(object.missedCrops)
        ? globalThis.Number(object.missedCrops)
        : isSet(object.missed_crops)
        ? globalThis.Number(object.missed_crops)
        : 0,
      notThinning: isSet(object.notThinning)
        ? globalThis.Number(object.notThinning)
        : isSet(object.not_thinning)
        ? globalThis.Number(object.not_thinning)
        : 0,
      notWeeding: isSet(object.notWeeding)
        ? globalThis.Number(object.notWeeding)
        : isSet(object.not_weeding)
        ? globalThis.Number(object.not_weeding)
        : 0,
      skippedCrops: isSet(object.skippedCrops)
        ? globalThis.Number(object.skippedCrops)
        : isSet(object.skipped_crops)
        ? globalThis.Number(object.skipped_crops)
        : 0,
      thinnedCrops: isSet(object.thinnedCrops)
        ? globalThis.Number(object.thinnedCrops)
        : isSet(object.thinned_crops)
        ? globalThis.Number(object.thinned_crops)
        : 0,
      totalCrops: isSet(object.totalCrops)
        ? globalThis.Number(object.totalCrops)
        : isSet(object.total_crops)
        ? globalThis.Number(object.total_crops)
        : 0,
      bandingPercentage: isSet(object.bandingPercentage)
        ? globalThis.Number(object.bandingPercentage)
        : isSet(object.banding_percentage)
        ? globalThis.Number(object.banding_percentage)
        : 0,
      thinningEfficiency: isSet(object.thinningEfficiency)
        ? globalThis.Number(object.thinningEfficiency)
        : isSet(object.thinning_efficiency)
        ? globalThis.Number(object.thinning_efficiency)
        : 0,
      cropId: isSet(object.cropId)
        ? globalThis.String(object.cropId)
        : isSet(object.crop_id)
        ? globalThis.String(object.crop_id)
        : "",
      crop: isSet(object.crop) ? globalThis.String(object.crop) : "",
      cropDensitySqFt: isSet(object.cropDensitySqFt)
        ? globalThis.Number(object.cropDensitySqFt)
        : isSet(object.crop_density_sq_ft)
        ? globalThis.Number(object.crop_density_sq_ft)
        : 0,
      avgCropSizeMm: isSet(object.avgCropSizeMm)
        ? globalThis.Number(object.avgCropSizeMm)
        : isSet(object.avg_crop_size_mm)
        ? globalThis.Number(object.avg_crop_size_mm)
        : 0,
      avgTargetableReqLaserTime: isSet(object.avgTargetableReqLaserTime)
        ? globalThis.Number(object.avgTargetableReqLaserTime)
        : isSet(object.avg_targetable_req_laser_time)
        ? globalThis.Number(object.avg_targetable_req_laser_time)
        : 0,
      avgUntargetableReqLaserTime: isSet(object.avgUntargetableReqLaserTime)
        ? globalThis.Number(object.avgUntargetableReqLaserTime)
        : isSet(object.avg_untargetable_req_laser_time)
        ? globalThis.Number(object.avg_untargetable_req_laser_time)
        : 0,
      validCrops: isSet(object.validCrops)
        ? globalThis.Number(object.validCrops)
        : isSet(object.valid_crops)
        ? globalThis.Number(object.valid_crops)
        : 0,
      operatorEffectiveness: isSet(object.operatorEffectiveness)
        ? globalThis.Number(object.operatorEffectiveness)
        : isSet(object.operator_effectiveness)
        ? globalThis.Number(object.operator_effectiveness)
        : 0,
      targetWeedingTimeSeconds: isSet(object.targetWeedingTimeSeconds)
        ? globalThis.Number(object.targetWeedingTimeSeconds)
        : isSet(object.target_weeding_time_seconds)
        ? globalThis.Number(object.target_weeding_time_seconds)
        : 0,
      embeddingsActiveUptimeSeconds: isSet(object.embeddingsActiveUptimeSeconds)
        ? globalThis.Number(object.embeddingsActiveUptimeSeconds)
        : isSet(object.embeddings_active_uptime_seconds)
        ? globalThis.Number(object.embeddings_active_uptime_seconds)
        : 0,
      customerId: isSet(object.customerId)
        ? globalThis.String(object.customerId)
        : isSet(object.customer_id)
        ? globalThis.String(object.customer_id)
        : "",
      dataSource: isSet(object.dataSource)
        ? metricDataSourceFromJSON(object.dataSource)
        : isSet(object.data_source)
        ? metricDataSourceFromJSON(object.data_source)
        : 0,
      bandingProfiles: globalThis.Array.isArray(object?.bandingProfiles)
        ? object.bandingProfiles.map((e: any) => JigsawBandingProfile.fromJSON(e))
        : globalThis.Array.isArray(object?.banding_profiles)
        ? object.banding_profiles.map((e: any) => JigsawBandingProfile.fromJSON(e))
        : [],
      crops: globalThis.Array.isArray(object?.crops)
        ? object.crops.map((e: any) => JigsawCrop.fromJSON(e))
        : [],
      jobs: globalThis.Array.isArray(object?.jobs)
        ? object.jobs.map((e: any) => JigsawJob.fromJSON(e))
        : [],
      overallEfficiency: isSet(object.overallEfficiency)
        ? globalThis.Number(object.overallEfficiency)
        : isSet(object.overall_efficiency)
        ? globalThis.Number(object.overall_efficiency)
        : 0,
      totalWeedsInBand: isSet(object.totalWeedsInBand)
        ? globalThis.Number(object.totalWeedsInBand)
        : isSet(object.total_weeds_in_band)
        ? globalThis.Number(object.total_weeds_in_band)
        : 0,
      weedsTypeFractionBroadleaf: isSet(object.weedsTypeFractionBroadleaf)
        ? globalThis.Number(object.weedsTypeFractionBroadleaf)
        : isSet(object.weeds_type_fraction_broadleaf)
        ? globalThis.Number(object.weeds_type_fraction_broadleaf)
        : 0,
      weedsTypeFractionGrass: isSet(object.weedsTypeFractionGrass)
        ? globalThis.Number(object.weedsTypeFractionGrass)
        : isSet(object.weeds_type_fraction_grass)
        ? globalThis.Number(object.weeds_type_fraction_grass)
        : 0,
      weedsTypeFractionOffshoot: isSet(object.weedsTypeFractionOffshoot)
        ? globalThis.Number(object.weedsTypeFractionOffshoot)
        : isSet(object.weeds_type_fraction_offshoot)
        ? globalThis.Number(object.weeds_type_fraction_offshoot)
        : 0,
      weedsTypeFractionPurslane: isSet(object.weedsTypeFractionPurslane)
        ? globalThis.Number(object.weedsTypeFractionPurslane)
        : isSet(object.weeds_type_fraction_purslane)
        ? globalThis.Number(object.weeds_type_fraction_purslane)
        : 0,
      notWeedingWeeds: isSet(object.notWeedingWeeds)
        ? globalThis.Number(object.notWeedingWeeds)
        : isSet(object.not_weeding_weeds)
        ? globalThis.Number(object.not_weeding_weeds)
        : 0,
      weedMetricsByCategory: isObject(object.weedMetricsByCategory)
        ? (globalThis.Object.entries(object.weedMetricsByCategory) as [string, any][]).reduce(
          (acc: { [key: string]: WeedMetrics }, [key, value]: [string, any]) => {
            acc[key] = WeedMetrics.fromJSON(value);
            return acc;
          },
          {},
        )
        : isObject(object.weed_metrics_by_category)
        ? (globalThis.Object.entries(object.weed_metrics_by_category) as [string, any][]).reduce(
          (acc: { [key: string]: WeedMetrics }, [key, value]: [string, any]) => {
            acc[key] = WeedMetrics.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
      cropMetricsByCategory: isObject(object.cropMetricsByCategory)
        ? (globalThis.Object.entries(object.cropMetricsByCategory) as [string, any][]).reduce(
          (acc: { [key: string]: CropMetrics }, [key, value]: [string, any]) => {
            acc[key] = CropMetrics.fromJSON(value);
            return acc;
          },
          {},
        )
        : isObject(object.crop_metrics_by_category)
        ? (globalThis.Object.entries(object.crop_metrics_by_category) as [string, any][]).reduce(
          (acc: { [key: string]: CropMetrics }, [key, value]: [string, any]) => {
            acc[key] = CropMetrics.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
      latestCrop: isSet(object.latestCrop)
        ? JigsawCrop.fromJSON(object.latestCrop)
        : isSet(object.latest_crop)
        ? JigsawCrop.fromJSON(object.latest_crop)
        : undefined,
      plantProfileMetrics: globalThis.Array.isArray(object?.plantProfileMetrics)
        ? object.plantProfileMetrics.map((e: any) => PlantProfileMetrics.fromJSON(e))
        : globalThis.Array.isArray(object?.plant_profile_metrics)
        ? object.plant_profile_metrics.map((e: any) => PlantProfileMetrics.fromJSON(e))
        : [],
      entryTimingGrade: isSet(object.entryTimingGrade)
        ? entryTimingGradeFromJSON(object.entryTimingGrade)
        : isSet(object.entry_timing_grade)
        ? entryTimingGradeFromJSON(object.entry_timing_grade)
        : 0,
      thinningProfiles: globalThis.Array.isArray(object?.thinningProfiles)
        ? object.thinningProfiles.map((e: any) => JigsawThinningProfile.fromJSON(e))
        : globalThis.Array.isArray(object?.thinning_profiles)
        ? object.thinning_profiles.map((e: any) => JigsawThinningProfile.fromJSON(e))
        : [],
    };
  },

  toJSON(message: DailyMetricResponse): unknown {
    const obj: any = {};
    if (message.db !== undefined) {
      obj.db = DB.toJSON(message.db);
    }
    if (message.serial !== "") {
      obj.serial = message.serial;
    }
    if (message.robotId !== 0) {
      obj.robotId = Math.round(message.robotId);
    }
    if (message.date !== "") {
      obj.date = message.date;
    }
    if (message.jobId !== "") {
      obj.jobId = message.jobId;
    }
    if (message.jobName !== "") {
      obj.jobName = message.jobName;
    }
    if (message.acresWeeded !== 0) {
      obj.acresWeeded = message.acresWeeded;
    }
    if (message.avgSpeedMph !== 0) {
      obj.avgSpeedMph = message.avgSpeedMph;
    }
    if (message.avgWeedSizeMm !== 0) {
      obj.avgWeedSizeMm = message.avgWeedSizeMm;
    }
    if (message.bandingConfigName !== "") {
      obj.bandingConfigName = message.bandingConfigName;
    }
    if (message.bandingEnabled !== false) {
      obj.bandingEnabled = message.bandingEnabled;
    }
    if (message.coverageSpeedAcresHr !== 0) {
      obj.coverageSpeedAcresHr = message.coverageSpeedAcresHr;
    }
    if (message.distanceWeededMeters !== 0) {
      obj.distanceWeededMeters = message.distanceWeededMeters;
    }
    if (message.killedWeeds !== 0) {
      obj.killedWeeds = Math.round(message.killedWeeds);
    }
    if (message.missedWeeds !== 0) {
      obj.missedWeeds = Math.round(message.missedWeeds);
    }
    if (message.skippedWeeds !== 0) {
      obj.skippedWeeds = Math.round(message.skippedWeeds);
    }
    if (message.timeEfficiency !== 0) {
      obj.timeEfficiency = message.timeEfficiency;
    }
    if (message.totalWeeds !== 0) {
      obj.totalWeeds = Math.round(message.totalWeeds);
    }
    if (message.uptimeSeconds !== 0) {
      obj.uptimeSeconds = message.uptimeSeconds;
    }
    if (message.weedDensitySqFt !== 0) {
      obj.weedDensitySqFt = message.weedDensitySqFt;
    }
    if (message.weedingUptimeSeconds !== 0) {
      obj.weedingUptimeSeconds = message.weedingUptimeSeconds;
    }
    if (message.weedingEfficiency !== 0) {
      obj.weedingEfficiency = message.weedingEfficiency;
    }
    if (message.weedsTypeCountBroadleaf !== 0) {
      obj.weedsTypeCountBroadleaf = Math.round(message.weedsTypeCountBroadleaf);
    }
    if (message.weedsTypeCountGrass !== 0) {
      obj.weedsTypeCountGrass = Math.round(message.weedsTypeCountGrass);
    }
    if (message.weedsTypeCountOffshoot !== 0) {
      obj.weedsTypeCountOffshoot = Math.round(message.weedsTypeCountOffshoot);
    }
    if (message.weedsTypeCountPurslane !== 0) {
      obj.weedsTypeCountPurslane = Math.round(message.weedsTypeCountPurslane);
    }
    if (message.keptCrops !== 0) {
      obj.keptCrops = Math.round(message.keptCrops);
    }
    if (message.missedCrops !== 0) {
      obj.missedCrops = Math.round(message.missedCrops);
    }
    if (message.notThinning !== 0) {
      obj.notThinning = Math.round(message.notThinning);
    }
    if (message.notWeeding !== 0) {
      obj.notWeeding = Math.round(message.notWeeding);
    }
    if (message.skippedCrops !== 0) {
      obj.skippedCrops = Math.round(message.skippedCrops);
    }
    if (message.thinnedCrops !== 0) {
      obj.thinnedCrops = Math.round(message.thinnedCrops);
    }
    if (message.totalCrops !== 0) {
      obj.totalCrops = Math.round(message.totalCrops);
    }
    if (message.bandingPercentage !== 0) {
      obj.bandingPercentage = message.bandingPercentage;
    }
    if (message.thinningEfficiency !== 0) {
      obj.thinningEfficiency = message.thinningEfficiency;
    }
    if (message.cropId !== "") {
      obj.cropId = message.cropId;
    }
    if (message.crop !== "") {
      obj.crop = message.crop;
    }
    if (message.cropDensitySqFt !== 0) {
      obj.cropDensitySqFt = message.cropDensitySqFt;
    }
    if (message.avgCropSizeMm !== 0) {
      obj.avgCropSizeMm = message.avgCropSizeMm;
    }
    if (message.avgTargetableReqLaserTime !== 0) {
      obj.avgTargetableReqLaserTime = Math.round(message.avgTargetableReqLaserTime);
    }
    if (message.avgUntargetableReqLaserTime !== 0) {
      obj.avgUntargetableReqLaserTime = Math.round(message.avgUntargetableReqLaserTime);
    }
    if (message.validCrops !== 0) {
      obj.validCrops = Math.round(message.validCrops);
    }
    if (message.operatorEffectiveness !== 0) {
      obj.operatorEffectiveness = message.operatorEffectiveness;
    }
    if (message.targetWeedingTimeSeconds !== 0) {
      obj.targetWeedingTimeSeconds = Math.round(message.targetWeedingTimeSeconds);
    }
    if (message.embeddingsActiveUptimeSeconds !== 0) {
      obj.embeddingsActiveUptimeSeconds = message.embeddingsActiveUptimeSeconds;
    }
    if (message.customerId !== "") {
      obj.customerId = message.customerId;
    }
    if (message.dataSource !== 0) {
      obj.dataSource = metricDataSourceToJSON(message.dataSource);
    }
    if (message.bandingProfiles?.length) {
      obj.bandingProfiles = message.bandingProfiles.map((e) => JigsawBandingProfile.toJSON(e));
    }
    if (message.crops?.length) {
      obj.crops = message.crops.map((e) => JigsawCrop.toJSON(e));
    }
    if (message.jobs?.length) {
      obj.jobs = message.jobs.map((e) => JigsawJob.toJSON(e));
    }
    if (message.overallEfficiency !== 0) {
      obj.overallEfficiency = message.overallEfficiency;
    }
    if (message.totalWeedsInBand !== 0) {
      obj.totalWeedsInBand = message.totalWeedsInBand;
    }
    if (message.weedsTypeFractionBroadleaf !== 0) {
      obj.weedsTypeFractionBroadleaf = message.weedsTypeFractionBroadleaf;
    }
    if (message.weedsTypeFractionGrass !== 0) {
      obj.weedsTypeFractionGrass = message.weedsTypeFractionGrass;
    }
    if (message.weedsTypeFractionOffshoot !== 0) {
      obj.weedsTypeFractionOffshoot = message.weedsTypeFractionOffshoot;
    }
    if (message.weedsTypeFractionPurslane !== 0) {
      obj.weedsTypeFractionPurslane = message.weedsTypeFractionPurslane;
    }
    if (message.notWeedingWeeds !== 0) {
      obj.notWeedingWeeds = Math.round(message.notWeedingWeeds);
    }
    if (message.weedMetricsByCategory) {
      const entries = globalThis.Object.entries(message.weedMetricsByCategory) as [string, WeedMetrics][];
      if (entries.length > 0) {
        obj.weedMetricsByCategory = {};
        entries.forEach(([k, v]) => {
          obj.weedMetricsByCategory[k] = WeedMetrics.toJSON(v);
        });
      }
    }
    if (message.cropMetricsByCategory) {
      const entries = globalThis.Object.entries(message.cropMetricsByCategory) as [string, CropMetrics][];
      if (entries.length > 0) {
        obj.cropMetricsByCategory = {};
        entries.forEach(([k, v]) => {
          obj.cropMetricsByCategory[k] = CropMetrics.toJSON(v);
        });
      }
    }
    if (message.latestCrop !== undefined) {
      obj.latestCrop = JigsawCrop.toJSON(message.latestCrop);
    }
    if (message.plantProfileMetrics?.length) {
      obj.plantProfileMetrics = message.plantProfileMetrics.map((e) => PlantProfileMetrics.toJSON(e));
    }
    if (message.entryTimingGrade !== 0) {
      obj.entryTimingGrade = entryTimingGradeToJSON(message.entryTimingGrade);
    }
    if (message.thinningProfiles?.length) {
      obj.thinningProfiles = message.thinningProfiles.map((e) => JigsawThinningProfile.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DailyMetricResponse>, I>>(base?: I): DailyMetricResponse {
    return DailyMetricResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DailyMetricResponse>, I>>(object: I): DailyMetricResponse {
    const message = createBaseDailyMetricResponse();
    message.db = (object.db !== undefined && object.db !== null) ? DB.fromPartial(object.db) : undefined;
    message.serial = object.serial ?? "";
    message.robotId = object.robotId ?? 0;
    message.date = object.date ?? "";
    message.jobId = object.jobId ?? "";
    message.jobName = object.jobName ?? "";
    message.acresWeeded = object.acresWeeded ?? 0;
    message.avgSpeedMph = object.avgSpeedMph ?? 0;
    message.avgWeedSizeMm = object.avgWeedSizeMm ?? 0;
    message.bandingConfigName = object.bandingConfigName ?? "";
    message.bandingEnabled = object.bandingEnabled ?? false;
    message.coverageSpeedAcresHr = object.coverageSpeedAcresHr ?? 0;
    message.distanceWeededMeters = object.distanceWeededMeters ?? 0;
    message.killedWeeds = object.killedWeeds ?? 0;
    message.missedWeeds = object.missedWeeds ?? 0;
    message.skippedWeeds = object.skippedWeeds ?? 0;
    message.timeEfficiency = object.timeEfficiency ?? 0;
    message.totalWeeds = object.totalWeeds ?? 0;
    message.uptimeSeconds = object.uptimeSeconds ?? 0;
    message.weedDensitySqFt = object.weedDensitySqFt ?? 0;
    message.weedingUptimeSeconds = object.weedingUptimeSeconds ?? 0;
    message.weedingEfficiency = object.weedingEfficiency ?? 0;
    message.weedsTypeCountBroadleaf = object.weedsTypeCountBroadleaf ?? 0;
    message.weedsTypeCountGrass = object.weedsTypeCountGrass ?? 0;
    message.weedsTypeCountOffshoot = object.weedsTypeCountOffshoot ?? 0;
    message.weedsTypeCountPurslane = object.weedsTypeCountPurslane ?? 0;
    message.keptCrops = object.keptCrops ?? 0;
    message.missedCrops = object.missedCrops ?? 0;
    message.notThinning = object.notThinning ?? 0;
    message.notWeeding = object.notWeeding ?? 0;
    message.skippedCrops = object.skippedCrops ?? 0;
    message.thinnedCrops = object.thinnedCrops ?? 0;
    message.totalCrops = object.totalCrops ?? 0;
    message.bandingPercentage = object.bandingPercentage ?? 0;
    message.thinningEfficiency = object.thinningEfficiency ?? 0;
    message.cropId = object.cropId ?? "";
    message.crop = object.crop ?? "";
    message.cropDensitySqFt = object.cropDensitySqFt ?? 0;
    message.avgCropSizeMm = object.avgCropSizeMm ?? 0;
    message.avgTargetableReqLaserTime = object.avgTargetableReqLaserTime ?? 0;
    message.avgUntargetableReqLaserTime = object.avgUntargetableReqLaserTime ?? 0;
    message.validCrops = object.validCrops ?? 0;
    message.operatorEffectiveness = object.operatorEffectiveness ?? 0;
    message.targetWeedingTimeSeconds = object.targetWeedingTimeSeconds ?? 0;
    message.embeddingsActiveUptimeSeconds = object.embeddingsActiveUptimeSeconds ?? 0;
    message.customerId = object.customerId ?? "";
    message.dataSource = object.dataSource ?? 0;
    message.bandingProfiles = object.bandingProfiles?.map((e) => JigsawBandingProfile.fromPartial(e)) || [];
    message.crops = object.crops?.map((e) => JigsawCrop.fromPartial(e)) || [];
    message.jobs = object.jobs?.map((e) => JigsawJob.fromPartial(e)) || [];
    message.overallEfficiency = object.overallEfficiency ?? 0;
    message.totalWeedsInBand = object.totalWeedsInBand ?? 0;
    message.weedsTypeFractionBroadleaf = object.weedsTypeFractionBroadleaf ?? 0;
    message.weedsTypeFractionGrass = object.weedsTypeFractionGrass ?? 0;
    message.weedsTypeFractionOffshoot = object.weedsTypeFractionOffshoot ?? 0;
    message.weedsTypeFractionPurslane = object.weedsTypeFractionPurslane ?? 0;
    message.notWeedingWeeds = object.notWeedingWeeds ?? 0;
    message.weedMetricsByCategory =
      (globalThis.Object.entries(object.weedMetricsByCategory ?? {}) as [string, WeedMetrics][]).reduce(
        (acc: { [key: string]: WeedMetrics }, [key, value]: [string, WeedMetrics]) => {
          if (value !== undefined) {
            acc[key] = WeedMetrics.fromPartial(value);
          }
          return acc;
        },
        {},
      );
    message.cropMetricsByCategory =
      (globalThis.Object.entries(object.cropMetricsByCategory ?? {}) as [string, CropMetrics][]).reduce(
        (acc: { [key: string]: CropMetrics }, [key, value]: [string, CropMetrics]) => {
          if (value !== undefined) {
            acc[key] = CropMetrics.fromPartial(value);
          }
          return acc;
        },
        {},
      );
    message.latestCrop = (object.latestCrop !== undefined && object.latestCrop !== null)
      ? JigsawCrop.fromPartial(object.latestCrop)
      : undefined;
    message.plantProfileMetrics = object.plantProfileMetrics?.map((e) => PlantProfileMetrics.fromPartial(e)) || [];
    message.entryTimingGrade = object.entryTimingGrade ?? 0;
    message.thinningProfiles = object.thinningProfiles?.map((e) => JigsawThinningProfile.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDailyMetricResponse_WeedMetricsByCategoryEntry(): DailyMetricResponse_WeedMetricsByCategoryEntry {
  return { key: "", value: undefined };
}

export const DailyMetricResponse_WeedMetricsByCategoryEntry: MessageFns<
  DailyMetricResponse_WeedMetricsByCategoryEntry
> = {
  encode(
    message: DailyMetricResponse_WeedMetricsByCategoryEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      WeedMetrics.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DailyMetricResponse_WeedMetricsByCategoryEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDailyMetricResponse_WeedMetricsByCategoryEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = WeedMetrics.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DailyMetricResponse_WeedMetricsByCategoryEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? WeedMetrics.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: DailyMetricResponse_WeedMetricsByCategoryEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = WeedMetrics.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DailyMetricResponse_WeedMetricsByCategoryEntry>, I>>(
    base?: I,
  ): DailyMetricResponse_WeedMetricsByCategoryEntry {
    return DailyMetricResponse_WeedMetricsByCategoryEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DailyMetricResponse_WeedMetricsByCategoryEntry>, I>>(
    object: I,
  ): DailyMetricResponse_WeedMetricsByCategoryEntry {
    const message = createBaseDailyMetricResponse_WeedMetricsByCategoryEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? WeedMetrics.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseDailyMetricResponse_CropMetricsByCategoryEntry(): DailyMetricResponse_CropMetricsByCategoryEntry {
  return { key: "", value: undefined };
}

export const DailyMetricResponse_CropMetricsByCategoryEntry: MessageFns<
  DailyMetricResponse_CropMetricsByCategoryEntry
> = {
  encode(
    message: DailyMetricResponse_CropMetricsByCategoryEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      CropMetrics.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DailyMetricResponse_CropMetricsByCategoryEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDailyMetricResponse_CropMetricsByCategoryEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = CropMetrics.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DailyMetricResponse_CropMetricsByCategoryEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? CropMetrics.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: DailyMetricResponse_CropMetricsByCategoryEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = CropMetrics.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DailyMetricResponse_CropMetricsByCategoryEntry>, I>>(
    base?: I,
  ): DailyMetricResponse_CropMetricsByCategoryEntry {
    return DailyMetricResponse_CropMetricsByCategoryEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DailyMetricResponse_CropMetricsByCategoryEntry>, I>>(
    object: I,
  ): DailyMetricResponse_CropMetricsByCategoryEntry {
    const message = createBaseDailyMetricResponse_CropMetricsByCategoryEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? CropMetrics.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseJigsawBandingProfile(): JigsawBandingProfile {
  return { id: "", name: "" };
}

export const JigsawBandingProfile: MessageFns<JigsawBandingProfile> = {
  encode(message: JigsawBandingProfile, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JigsawBandingProfile {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJigsawBandingProfile();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JigsawBandingProfile {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
    };
  },

  toJSON(message: JigsawBandingProfile): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JigsawBandingProfile>, I>>(base?: I): JigsawBandingProfile {
    return JigsawBandingProfile.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JigsawBandingProfile>, I>>(object: I): JigsawBandingProfile {
    const message = createBaseJigsawBandingProfile();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    return message;
  },
};

function createBaseJigsawThinningProfile(): JigsawThinningProfile {
  return { id: "", name: "" };
}

export const JigsawThinningProfile: MessageFns<JigsawThinningProfile> = {
  encode(message: JigsawThinningProfile, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JigsawThinningProfile {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJigsawThinningProfile();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JigsawThinningProfile {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
    };
  },

  toJSON(message: JigsawThinningProfile): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JigsawThinningProfile>, I>>(base?: I): JigsawThinningProfile {
    return JigsawThinningProfile.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JigsawThinningProfile>, I>>(object: I): JigsawThinningProfile {
    const message = createBaseJigsawThinningProfile();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    return message;
  },
};

function createBaseJigsawCrop(): JigsawCrop {
  return { id: "", cropType: 0, localizedName: "" };
}

export const JigsawCrop: MessageFns<JigsawCrop> = {
  encode(message: JigsawCrop, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.cropType !== 0) {
      writer.uint32(24).int32(message.cropType);
    }
    if (message.localizedName !== "") {
      writer.uint32(34).string(message.localizedName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JigsawCrop {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJigsawCrop();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.cropType = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.localizedName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JigsawCrop {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      cropType: isSet(object.cropType)
        ? jigsawCrop_CropTypeFromJSON(object.cropType)
        : isSet(object.crop_type)
        ? jigsawCrop_CropTypeFromJSON(object.crop_type)
        : 0,
      localizedName: isSet(object.localizedName)
        ? globalThis.String(object.localizedName)
        : isSet(object.localized_name)
        ? globalThis.String(object.localized_name)
        : "",
    };
  },

  toJSON(message: JigsawCrop): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.cropType !== 0) {
      obj.cropType = jigsawCrop_CropTypeToJSON(message.cropType);
    }
    if (message.localizedName !== "") {
      obj.localizedName = message.localizedName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JigsawCrop>, I>>(base?: I): JigsawCrop {
    return JigsawCrop.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JigsawCrop>, I>>(object: I): JigsawCrop {
    const message = createBaseJigsawCrop();
    message.id = object.id ?? "";
    message.cropType = object.cropType ?? 0;
    message.localizedName = object.localizedName ?? "";
    return message;
  },
};

function createBaseJigsawJob(): JigsawJob {
  return { id: "", name: "" };
}

export const JigsawJob: MessageFns<JigsawJob> = {
  encode(message: JigsawJob, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JigsawJob {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJigsawJob();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JigsawJob {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
    };
  },

  toJSON(message: JigsawJob): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JigsawJob>, I>>(base?: I): JigsawJob {
    return JigsawJob.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JigsawJob>, I>>(object: I): JigsawJob {
    const message = createBaseJigsawJob();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    return message;
  },
};

function createBaseDailyMetricsByDateResponse(): DailyMetricsByDateResponse {
  return { metrics: {} };
}

export const DailyMetricsByDateResponse: MessageFns<DailyMetricsByDateResponse> = {
  encode(message: DailyMetricsByDateResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.metrics).forEach(([key, value]: [string, DailyMetricResponse]) => {
      DailyMetricsByDateResponse_MetricsEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DailyMetricsByDateResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDailyMetricsByDateResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = DailyMetricsByDateResponse_MetricsEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.metrics[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DailyMetricsByDateResponse {
    return {
      metrics: isObject(object.metrics)
        ? (globalThis.Object.entries(object.metrics) as [string, any][]).reduce(
          (acc: { [key: string]: DailyMetricResponse }, [key, value]: [string, any]) => {
            acc[key] = DailyMetricResponse.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: DailyMetricsByDateResponse): unknown {
    const obj: any = {};
    if (message.metrics) {
      const entries = globalThis.Object.entries(message.metrics) as [string, DailyMetricResponse][];
      if (entries.length > 0) {
        obj.metrics = {};
        entries.forEach(([k, v]) => {
          obj.metrics[k] = DailyMetricResponse.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DailyMetricsByDateResponse>, I>>(base?: I): DailyMetricsByDateResponse {
    return DailyMetricsByDateResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DailyMetricsByDateResponse>, I>>(object: I): DailyMetricsByDateResponse {
    const message = createBaseDailyMetricsByDateResponse();
    message.metrics = (globalThis.Object.entries(object.metrics ?? {}) as [string, DailyMetricResponse][]).reduce(
      (acc: { [key: string]: DailyMetricResponse }, [key, value]: [string, DailyMetricResponse]) => {
        if (value !== undefined) {
          acc[key] = DailyMetricResponse.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseDailyMetricsByDateResponse_MetricsEntry(): DailyMetricsByDateResponse_MetricsEntry {
  return { key: "", value: undefined };
}

export const DailyMetricsByDateResponse_MetricsEntry: MessageFns<DailyMetricsByDateResponse_MetricsEntry> = {
  encode(message: DailyMetricsByDateResponse_MetricsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      DailyMetricResponse.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DailyMetricsByDateResponse_MetricsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDailyMetricsByDateResponse_MetricsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = DailyMetricResponse.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DailyMetricsByDateResponse_MetricsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? DailyMetricResponse.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: DailyMetricsByDateResponse_MetricsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = DailyMetricResponse.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DailyMetricsByDateResponse_MetricsEntry>, I>>(
    base?: I,
  ): DailyMetricsByDateResponse_MetricsEntry {
    return DailyMetricsByDateResponse_MetricsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DailyMetricsByDateResponse_MetricsEntry>, I>>(
    object: I,
  ): DailyMetricsByDateResponse_MetricsEntry {
    const message = createBaseDailyMetricsByDateResponse_MetricsEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? DailyMetricResponse.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseDailyMetricsByDateByRobotResponse(): DailyMetricsByDateByRobotResponse {
  return { metrics: {} };
}

export const DailyMetricsByDateByRobotResponse: MessageFns<DailyMetricsByDateByRobotResponse> = {
  encode(message: DailyMetricsByDateByRobotResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.metrics).forEach(([key, value]: [string, DailyMetricsByDateResponse]) => {
      DailyMetricsByDateByRobotResponse_MetricsEntry.encode({ key: key as any, value }, writer.uint32(10).fork())
        .join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DailyMetricsByDateByRobotResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDailyMetricsByDateByRobotResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = DailyMetricsByDateByRobotResponse_MetricsEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.metrics[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DailyMetricsByDateByRobotResponse {
    return {
      metrics: isObject(object.metrics)
        ? (globalThis.Object.entries(object.metrics) as [string, any][]).reduce(
          (acc: { [key: string]: DailyMetricsByDateResponse }, [key, value]: [string, any]) => {
            acc[key] = DailyMetricsByDateResponse.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: DailyMetricsByDateByRobotResponse): unknown {
    const obj: any = {};
    if (message.metrics) {
      const entries = globalThis.Object.entries(message.metrics) as [string, DailyMetricsByDateResponse][];
      if (entries.length > 0) {
        obj.metrics = {};
        entries.forEach(([k, v]) => {
          obj.metrics[k] = DailyMetricsByDateResponse.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DailyMetricsByDateByRobotResponse>, I>>(
    base?: I,
  ): DailyMetricsByDateByRobotResponse {
    return DailyMetricsByDateByRobotResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DailyMetricsByDateByRobotResponse>, I>>(
    object: I,
  ): DailyMetricsByDateByRobotResponse {
    const message = createBaseDailyMetricsByDateByRobotResponse();
    message.metrics = (globalThis.Object.entries(object.metrics ?? {}) as [string, DailyMetricsByDateResponse][])
      .reduce(
        (acc: { [key: string]: DailyMetricsByDateResponse }, [key, value]: [string, DailyMetricsByDateResponse]) => {
          if (value !== undefined) {
            acc[key] = DailyMetricsByDateResponse.fromPartial(value);
          }
          return acc;
        },
        {},
      );
    return message;
  },
};

function createBaseDailyMetricsByDateByRobotResponse_MetricsEntry(): DailyMetricsByDateByRobotResponse_MetricsEntry {
  return { key: "", value: undefined };
}

export const DailyMetricsByDateByRobotResponse_MetricsEntry: MessageFns<
  DailyMetricsByDateByRobotResponse_MetricsEntry
> = {
  encode(
    message: DailyMetricsByDateByRobotResponse_MetricsEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      DailyMetricsByDateResponse.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DailyMetricsByDateByRobotResponse_MetricsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDailyMetricsByDateByRobotResponse_MetricsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = DailyMetricsByDateResponse.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DailyMetricsByDateByRobotResponse_MetricsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? DailyMetricsByDateResponse.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: DailyMetricsByDateByRobotResponse_MetricsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = DailyMetricsByDateResponse.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DailyMetricsByDateByRobotResponse_MetricsEntry>, I>>(
    base?: I,
  ): DailyMetricsByDateByRobotResponse_MetricsEntry {
    return DailyMetricsByDateByRobotResponse_MetricsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DailyMetricsByDateByRobotResponse_MetricsEntry>, I>>(
    object: I,
  ): DailyMetricsByDateByRobotResponse_MetricsEntry {
    const message = createBaseDailyMetricsByDateByRobotResponse_MetricsEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? DailyMetricsByDateResponse.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseJobMetricResponse(): JobMetricResponse {
  return {
    db: undefined,
    serial: "",
    date: "",
    jobId: "",
    jobName: "",
    acresWeeded: 0,
    avgSpeedMph: 0,
    avgWeedSizeMm: 0,
    bandingConfigName: "",
    bandingEnabled: false,
    coverageSpeedAcresHr: 0,
    distanceWeededMeters: 0,
    killedWeeds: 0,
    missedWeeds: 0,
    skippedWeeds: 0,
    timeEfficiency: 0,
    totalWeeds: 0,
    uptimeSeconds: 0,
    weedDensitySqFt: 0,
    weedingUptimeSeconds: 0,
    weedingEfficiency: 0,
    weedsTypeCountBroadleaf: 0,
    weedsTypeCountGrass: 0,
    weedsTypeCountOffshoot: 0,
    weedsTypeCountPurslane: 0,
    keptCrops: 0,
    missedCrops: 0,
    notThinning: 0,
    notWeeding: 0,
    skippedCrops: 0,
    thinnedCrops: 0,
    totalCrops: 0,
    bandingPercentage: 0,
    thinningEfficiency: 0,
    cropId: "",
    crop: "",
    cropDensitySqFt: 0,
    avgCropSizeMm: 0,
    avgTargetableReqLaserTime: 0,
    avgUntargetableReqLaserTime: 0,
    validCrops: 0,
    operatorEffectiveness: 0,
    targetWeedingTimeSeconds: 0,
    embeddingsActiveUptimeSeconds: 0,
    customerId: "",
    jobStartTimestampMs: 0,
    jobStopTimestampMs: 0,
    jobCompleted: false,
    dataSource: 0,
    bandingProfiles: [],
    crops: [],
    overallEfficiency: 0,
    totalWeedsInBand: 0,
    weedsTypeFractionBroadleaf: 0,
    weedsTypeFractionGrass: 0,
    weedsTypeFractionOffshoot: 0,
    weedsTypeFractionPurslane: 0,
    weedMetricsByCategory: {},
    jobFirstSeen: undefined,
    jobLastSeen: undefined,
    latestCrop: undefined,
    entryTimingGrade: 0,
    thinningProfiles: [],
  };
}

export const JobMetricResponse: MessageFns<JobMetricResponse> = {
  encode(message: JobMetricResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.db !== undefined) {
      DB.encode(message.db, writer.uint32(10).fork()).join();
    }
    if (message.serial !== "") {
      writer.uint32(18).string(message.serial);
    }
    if (message.date !== "") {
      writer.uint32(26).string(message.date);
    }
    if (message.jobId !== "") {
      writer.uint32(34).string(message.jobId);
    }
    if (message.jobName !== "") {
      writer.uint32(42).string(message.jobName);
    }
    if (message.acresWeeded !== 0) {
      writer.uint32(53).float(message.acresWeeded);
    }
    if (message.avgSpeedMph !== 0) {
      writer.uint32(61).float(message.avgSpeedMph);
    }
    if (message.avgWeedSizeMm !== 0) {
      writer.uint32(69).float(message.avgWeedSizeMm);
    }
    if (message.bandingConfigName !== "") {
      writer.uint32(74).string(message.bandingConfigName);
    }
    if (message.bandingEnabled !== false) {
      writer.uint32(80).bool(message.bandingEnabled);
    }
    if (message.coverageSpeedAcresHr !== 0) {
      writer.uint32(93).float(message.coverageSpeedAcresHr);
    }
    if (message.distanceWeededMeters !== 0) {
      writer.uint32(101).float(message.distanceWeededMeters);
    }
    if (message.killedWeeds !== 0) {
      writer.uint32(104).int64(message.killedWeeds);
    }
    if (message.missedWeeds !== 0) {
      writer.uint32(112).int64(message.missedWeeds);
    }
    if (message.skippedWeeds !== 0) {
      writer.uint32(120).int64(message.skippedWeeds);
    }
    if (message.timeEfficiency !== 0) {
      writer.uint32(133).float(message.timeEfficiency);
    }
    if (message.totalWeeds !== 0) {
      writer.uint32(136).int64(message.totalWeeds);
    }
    if (message.uptimeSeconds !== 0) {
      writer.uint32(149).float(message.uptimeSeconds);
    }
    if (message.weedDensitySqFt !== 0) {
      writer.uint32(157).float(message.weedDensitySqFt);
    }
    if (message.weedingUptimeSeconds !== 0) {
      writer.uint32(165).float(message.weedingUptimeSeconds);
    }
    if (message.weedingEfficiency !== 0) {
      writer.uint32(173).float(message.weedingEfficiency);
    }
    if (message.weedsTypeCountBroadleaf !== 0) {
      writer.uint32(176).int64(message.weedsTypeCountBroadleaf);
    }
    if (message.weedsTypeCountGrass !== 0) {
      writer.uint32(184).int64(message.weedsTypeCountGrass);
    }
    if (message.weedsTypeCountOffshoot !== 0) {
      writer.uint32(192).int64(message.weedsTypeCountOffshoot);
    }
    if (message.weedsTypeCountPurslane !== 0) {
      writer.uint32(200).int64(message.weedsTypeCountPurslane);
    }
    if (message.keptCrops !== 0) {
      writer.uint32(208).int64(message.keptCrops);
    }
    if (message.missedCrops !== 0) {
      writer.uint32(216).int64(message.missedCrops);
    }
    if (message.notThinning !== 0) {
      writer.uint32(224).int64(message.notThinning);
    }
    if (message.notWeeding !== 0) {
      writer.uint32(232).int64(message.notWeeding);
    }
    if (message.skippedCrops !== 0) {
      writer.uint32(240).int64(message.skippedCrops);
    }
    if (message.thinnedCrops !== 0) {
      writer.uint32(248).int64(message.thinnedCrops);
    }
    if (message.totalCrops !== 0) {
      writer.uint32(256).int64(message.totalCrops);
    }
    if (message.bandingPercentage !== 0) {
      writer.uint32(269).float(message.bandingPercentage);
    }
    if (message.thinningEfficiency !== 0) {
      writer.uint32(277).float(message.thinningEfficiency);
    }
    if (message.cropId !== "") {
      writer.uint32(282).string(message.cropId);
    }
    if (message.crop !== "") {
      writer.uint32(290).string(message.crop);
    }
    if (message.cropDensitySqFt !== 0) {
      writer.uint32(301).float(message.cropDensitySqFt);
    }
    if (message.avgCropSizeMm !== 0) {
      writer.uint32(309).float(message.avgCropSizeMm);
    }
    if (message.avgTargetableReqLaserTime !== 0) {
      writer.uint32(312).int64(message.avgTargetableReqLaserTime);
    }
    if (message.avgUntargetableReqLaserTime !== 0) {
      writer.uint32(320).int64(message.avgUntargetableReqLaserTime);
    }
    if (message.validCrops !== 0) {
      writer.uint32(328).int64(message.validCrops);
    }
    if (message.operatorEffectiveness !== 0) {
      writer.uint32(341).float(message.operatorEffectiveness);
    }
    if (message.targetWeedingTimeSeconds !== 0) {
      writer.uint32(344).int64(message.targetWeedingTimeSeconds);
    }
    if (message.embeddingsActiveUptimeSeconds !== 0) {
      writer.uint32(357).float(message.embeddingsActiveUptimeSeconds);
    }
    if (message.customerId !== "") {
      writer.uint32(362).string(message.customerId);
    }
    if (message.jobStartTimestampMs !== 0) {
      writer.uint32(368).int64(message.jobStartTimestampMs);
    }
    if (message.jobStopTimestampMs !== 0) {
      writer.uint32(376).int64(message.jobStopTimestampMs);
    }
    if (message.jobCompleted !== false) {
      writer.uint32(384).bool(message.jobCompleted);
    }
    if (message.dataSource !== 0) {
      writer.uint32(392).int32(message.dataSource);
    }
    for (const v of message.bandingProfiles) {
      JigsawBandingProfile.encode(v!, writer.uint32(402).fork()).join();
    }
    for (const v of message.crops) {
      JigsawCrop.encode(v!, writer.uint32(410).fork()).join();
    }
    if (message.overallEfficiency !== 0) {
      writer.uint32(421).float(message.overallEfficiency);
    }
    if (message.totalWeedsInBand !== 0) {
      writer.uint32(429).float(message.totalWeedsInBand);
    }
    if (message.weedsTypeFractionBroadleaf !== 0) {
      writer.uint32(437).float(message.weedsTypeFractionBroadleaf);
    }
    if (message.weedsTypeFractionGrass !== 0) {
      writer.uint32(445).float(message.weedsTypeFractionGrass);
    }
    if (message.weedsTypeFractionOffshoot !== 0) {
      writer.uint32(453).float(message.weedsTypeFractionOffshoot);
    }
    if (message.weedsTypeFractionPurslane !== 0) {
      writer.uint32(461).float(message.weedsTypeFractionPurslane);
    }
    globalThis.Object.entries(message.weedMetricsByCategory).forEach(([key, value]: [string, WeedMetrics]) => {
      JobMetricResponse_WeedMetricsByCategoryEntry.encode({ key: key as any, value }, writer.uint32(466).fork()).join();
    });
    if (message.jobFirstSeen !== undefined) {
      Timestamp.encode(toTimestamp(message.jobFirstSeen), writer.uint32(474).fork()).join();
    }
    if (message.jobLastSeen !== undefined) {
      Timestamp.encode(toTimestamp(message.jobLastSeen), writer.uint32(482).fork()).join();
    }
    if (message.latestCrop !== undefined) {
      JigsawCrop.encode(message.latestCrop, writer.uint32(490).fork()).join();
    }
    if (message.entryTimingGrade !== 0) {
      writer.uint32(496).int32(message.entryTimingGrade);
    }
    for (const v of message.thinningProfiles) {
      JigsawThinningProfile.encode(v!, writer.uint32(506).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JobMetricResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJobMetricResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.db = DB.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.serial = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.date = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.jobId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.jobName = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.acresWeeded = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 61) {
            break;
          }

          message.avgSpeedMph = reader.float();
          continue;
        }
        case 8: {
          if (tag !== 69) {
            break;
          }

          message.avgWeedSizeMm = reader.float();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.bandingConfigName = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.bandingEnabled = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 93) {
            break;
          }

          message.coverageSpeedAcresHr = reader.float();
          continue;
        }
        case 12: {
          if (tag !== 101) {
            break;
          }

          message.distanceWeededMeters = reader.float();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.killedWeeds = longToNumber(reader.int64());
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.missedWeeds = longToNumber(reader.int64());
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.skippedWeeds = longToNumber(reader.int64());
          continue;
        }
        case 16: {
          if (tag !== 133) {
            break;
          }

          message.timeEfficiency = reader.float();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.totalWeeds = longToNumber(reader.int64());
          continue;
        }
        case 18: {
          if (tag !== 149) {
            break;
          }

          message.uptimeSeconds = reader.float();
          continue;
        }
        case 19: {
          if (tag !== 157) {
            break;
          }

          message.weedDensitySqFt = reader.float();
          continue;
        }
        case 20: {
          if (tag !== 165) {
            break;
          }

          message.weedingUptimeSeconds = reader.float();
          continue;
        }
        case 21: {
          if (tag !== 173) {
            break;
          }

          message.weedingEfficiency = reader.float();
          continue;
        }
        case 22: {
          if (tag !== 176) {
            break;
          }

          message.weedsTypeCountBroadleaf = longToNumber(reader.int64());
          continue;
        }
        case 23: {
          if (tag !== 184) {
            break;
          }

          message.weedsTypeCountGrass = longToNumber(reader.int64());
          continue;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.weedsTypeCountOffshoot = longToNumber(reader.int64());
          continue;
        }
        case 25: {
          if (tag !== 200) {
            break;
          }

          message.weedsTypeCountPurslane = longToNumber(reader.int64());
          continue;
        }
        case 26: {
          if (tag !== 208) {
            break;
          }

          message.keptCrops = longToNumber(reader.int64());
          continue;
        }
        case 27: {
          if (tag !== 216) {
            break;
          }

          message.missedCrops = longToNumber(reader.int64());
          continue;
        }
        case 28: {
          if (tag !== 224) {
            break;
          }

          message.notThinning = longToNumber(reader.int64());
          continue;
        }
        case 29: {
          if (tag !== 232) {
            break;
          }

          message.notWeeding = longToNumber(reader.int64());
          continue;
        }
        case 30: {
          if (tag !== 240) {
            break;
          }

          message.skippedCrops = longToNumber(reader.int64());
          continue;
        }
        case 31: {
          if (tag !== 248) {
            break;
          }

          message.thinnedCrops = longToNumber(reader.int64());
          continue;
        }
        case 32: {
          if (tag !== 256) {
            break;
          }

          message.totalCrops = longToNumber(reader.int64());
          continue;
        }
        case 33: {
          if (tag !== 269) {
            break;
          }

          message.bandingPercentage = reader.float();
          continue;
        }
        case 34: {
          if (tag !== 277) {
            break;
          }

          message.thinningEfficiency = reader.float();
          continue;
        }
        case 35: {
          if (tag !== 282) {
            break;
          }

          message.cropId = reader.string();
          continue;
        }
        case 36: {
          if (tag !== 290) {
            break;
          }

          message.crop = reader.string();
          continue;
        }
        case 37: {
          if (tag !== 301) {
            break;
          }

          message.cropDensitySqFt = reader.float();
          continue;
        }
        case 38: {
          if (tag !== 309) {
            break;
          }

          message.avgCropSizeMm = reader.float();
          continue;
        }
        case 39: {
          if (tag !== 312) {
            break;
          }

          message.avgTargetableReqLaserTime = longToNumber(reader.int64());
          continue;
        }
        case 40: {
          if (tag !== 320) {
            break;
          }

          message.avgUntargetableReqLaserTime = longToNumber(reader.int64());
          continue;
        }
        case 41: {
          if (tag !== 328) {
            break;
          }

          message.validCrops = longToNumber(reader.int64());
          continue;
        }
        case 42: {
          if (tag !== 341) {
            break;
          }

          message.operatorEffectiveness = reader.float();
          continue;
        }
        case 43: {
          if (tag !== 344) {
            break;
          }

          message.targetWeedingTimeSeconds = longToNumber(reader.int64());
          continue;
        }
        case 44: {
          if (tag !== 357) {
            break;
          }

          message.embeddingsActiveUptimeSeconds = reader.float();
          continue;
        }
        case 45: {
          if (tag !== 362) {
            break;
          }

          message.customerId = reader.string();
          continue;
        }
        case 46: {
          if (tag !== 368) {
            break;
          }

          message.jobStartTimestampMs = longToNumber(reader.int64());
          continue;
        }
        case 47: {
          if (tag !== 376) {
            break;
          }

          message.jobStopTimestampMs = longToNumber(reader.int64());
          continue;
        }
        case 48: {
          if (tag !== 384) {
            break;
          }

          message.jobCompleted = reader.bool();
          continue;
        }
        case 49: {
          if (tag !== 392) {
            break;
          }

          message.dataSource = reader.int32() as any;
          continue;
        }
        case 50: {
          if (tag !== 402) {
            break;
          }

          message.bandingProfiles.push(JigsawBandingProfile.decode(reader, reader.uint32()));
          continue;
        }
        case 51: {
          if (tag !== 410) {
            break;
          }

          message.crops.push(JigsawCrop.decode(reader, reader.uint32()));
          continue;
        }
        case 52: {
          if (tag !== 421) {
            break;
          }

          message.overallEfficiency = reader.float();
          continue;
        }
        case 53: {
          if (tag !== 429) {
            break;
          }

          message.totalWeedsInBand = reader.float();
          continue;
        }
        case 54: {
          if (tag !== 437) {
            break;
          }

          message.weedsTypeFractionBroadleaf = reader.float();
          continue;
        }
        case 55: {
          if (tag !== 445) {
            break;
          }

          message.weedsTypeFractionGrass = reader.float();
          continue;
        }
        case 56: {
          if (tag !== 453) {
            break;
          }

          message.weedsTypeFractionOffshoot = reader.float();
          continue;
        }
        case 57: {
          if (tag !== 461) {
            break;
          }

          message.weedsTypeFractionPurslane = reader.float();
          continue;
        }
        case 58: {
          if (tag !== 466) {
            break;
          }

          const entry58 = JobMetricResponse_WeedMetricsByCategoryEntry.decode(reader, reader.uint32());
          if (entry58.value !== undefined) {
            message.weedMetricsByCategory[entry58.key] = entry58.value;
          }
          continue;
        }
        case 59: {
          if (tag !== 474) {
            break;
          }

          message.jobFirstSeen = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 60: {
          if (tag !== 482) {
            break;
          }

          message.jobLastSeen = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 61: {
          if (tag !== 490) {
            break;
          }

          message.latestCrop = JigsawCrop.decode(reader, reader.uint32());
          continue;
        }
        case 62: {
          if (tag !== 496) {
            break;
          }

          message.entryTimingGrade = reader.int32() as any;
          continue;
        }
        case 63: {
          if (tag !== 506) {
            break;
          }

          message.thinningProfiles.push(JigsawThinningProfile.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JobMetricResponse {
    return {
      db: isSet(object.db) ? DB.fromJSON(object.db) : undefined,
      serial: isSet(object.serial) ? globalThis.String(object.serial) : "",
      date: isSet(object.date) ? globalThis.String(object.date) : "",
      jobId: isSet(object.jobId)
        ? globalThis.String(object.jobId)
        : isSet(object.job_id)
        ? globalThis.String(object.job_id)
        : "",
      jobName: isSet(object.jobName)
        ? globalThis.String(object.jobName)
        : isSet(object.job_name)
        ? globalThis.String(object.job_name)
        : "",
      acresWeeded: isSet(object.acresWeeded)
        ? globalThis.Number(object.acresWeeded)
        : isSet(object.acres_weeded)
        ? globalThis.Number(object.acres_weeded)
        : 0,
      avgSpeedMph: isSet(object.avgSpeedMph)
        ? globalThis.Number(object.avgSpeedMph)
        : isSet(object.avg_speed_mph)
        ? globalThis.Number(object.avg_speed_mph)
        : 0,
      avgWeedSizeMm: isSet(object.avgWeedSizeMm)
        ? globalThis.Number(object.avgWeedSizeMm)
        : isSet(object.avg_weed_size_mm)
        ? globalThis.Number(object.avg_weed_size_mm)
        : 0,
      bandingConfigName: isSet(object.bandingConfigName)
        ? globalThis.String(object.bandingConfigName)
        : isSet(object.banding_config_name)
        ? globalThis.String(object.banding_config_name)
        : "",
      bandingEnabled: isSet(object.bandingEnabled)
        ? globalThis.Boolean(object.bandingEnabled)
        : isSet(object.banding_enabled)
        ? globalThis.Boolean(object.banding_enabled)
        : false,
      coverageSpeedAcresHr: isSet(object.coverageSpeedAcresHr)
        ? globalThis.Number(object.coverageSpeedAcresHr)
        : isSet(object.coverage_speed_acres_hr)
        ? globalThis.Number(object.coverage_speed_acres_hr)
        : 0,
      distanceWeededMeters: isSet(object.distanceWeededMeters)
        ? globalThis.Number(object.distanceWeededMeters)
        : isSet(object.distance_weeded_meters)
        ? globalThis.Number(object.distance_weeded_meters)
        : 0,
      killedWeeds: isSet(object.killedWeeds)
        ? globalThis.Number(object.killedWeeds)
        : isSet(object.killed_weeds)
        ? globalThis.Number(object.killed_weeds)
        : 0,
      missedWeeds: isSet(object.missedWeeds)
        ? globalThis.Number(object.missedWeeds)
        : isSet(object.missed_weeds)
        ? globalThis.Number(object.missed_weeds)
        : 0,
      skippedWeeds: isSet(object.skippedWeeds)
        ? globalThis.Number(object.skippedWeeds)
        : isSet(object.skipped_weeds)
        ? globalThis.Number(object.skipped_weeds)
        : 0,
      timeEfficiency: isSet(object.timeEfficiency)
        ? globalThis.Number(object.timeEfficiency)
        : isSet(object.time_efficiency)
        ? globalThis.Number(object.time_efficiency)
        : 0,
      totalWeeds: isSet(object.totalWeeds)
        ? globalThis.Number(object.totalWeeds)
        : isSet(object.total_weeds)
        ? globalThis.Number(object.total_weeds)
        : 0,
      uptimeSeconds: isSet(object.uptimeSeconds)
        ? globalThis.Number(object.uptimeSeconds)
        : isSet(object.uptime_seconds)
        ? globalThis.Number(object.uptime_seconds)
        : 0,
      weedDensitySqFt: isSet(object.weedDensitySqFt)
        ? globalThis.Number(object.weedDensitySqFt)
        : isSet(object.weed_density_sq_ft)
        ? globalThis.Number(object.weed_density_sq_ft)
        : 0,
      weedingUptimeSeconds: isSet(object.weedingUptimeSeconds)
        ? globalThis.Number(object.weedingUptimeSeconds)
        : isSet(object.weeding_uptime_seconds)
        ? globalThis.Number(object.weeding_uptime_seconds)
        : 0,
      weedingEfficiency: isSet(object.weedingEfficiency)
        ? globalThis.Number(object.weedingEfficiency)
        : isSet(object.weeding_efficiency)
        ? globalThis.Number(object.weeding_efficiency)
        : 0,
      weedsTypeCountBroadleaf: isSet(object.weedsTypeCountBroadleaf)
        ? globalThis.Number(object.weedsTypeCountBroadleaf)
        : isSet(object.weeds_type_count_broadleaf)
        ? globalThis.Number(object.weeds_type_count_broadleaf)
        : 0,
      weedsTypeCountGrass: isSet(object.weedsTypeCountGrass)
        ? globalThis.Number(object.weedsTypeCountGrass)
        : isSet(object.weeds_type_count_grass)
        ? globalThis.Number(object.weeds_type_count_grass)
        : 0,
      weedsTypeCountOffshoot: isSet(object.weedsTypeCountOffshoot)
        ? globalThis.Number(object.weedsTypeCountOffshoot)
        : isSet(object.weeds_type_count_offshoot)
        ? globalThis.Number(object.weeds_type_count_offshoot)
        : 0,
      weedsTypeCountPurslane: isSet(object.weedsTypeCountPurslane)
        ? globalThis.Number(object.weedsTypeCountPurslane)
        : isSet(object.weeds_type_count_purslane)
        ? globalThis.Number(object.weeds_type_count_purslane)
        : 0,
      keptCrops: isSet(object.keptCrops)
        ? globalThis.Number(object.keptCrops)
        : isSet(object.kept_crops)
        ? globalThis.Number(object.kept_crops)
        : 0,
      missedCrops: isSet(object.missedCrops)
        ? globalThis.Number(object.missedCrops)
        : isSet(object.missed_crops)
        ? globalThis.Number(object.missed_crops)
        : 0,
      notThinning: isSet(object.notThinning)
        ? globalThis.Number(object.notThinning)
        : isSet(object.not_thinning)
        ? globalThis.Number(object.not_thinning)
        : 0,
      notWeeding: isSet(object.notWeeding)
        ? globalThis.Number(object.notWeeding)
        : isSet(object.not_weeding)
        ? globalThis.Number(object.not_weeding)
        : 0,
      skippedCrops: isSet(object.skippedCrops)
        ? globalThis.Number(object.skippedCrops)
        : isSet(object.skipped_crops)
        ? globalThis.Number(object.skipped_crops)
        : 0,
      thinnedCrops: isSet(object.thinnedCrops)
        ? globalThis.Number(object.thinnedCrops)
        : isSet(object.thinned_crops)
        ? globalThis.Number(object.thinned_crops)
        : 0,
      totalCrops: isSet(object.totalCrops)
        ? globalThis.Number(object.totalCrops)
        : isSet(object.total_crops)
        ? globalThis.Number(object.total_crops)
        : 0,
      bandingPercentage: isSet(object.bandingPercentage)
        ? globalThis.Number(object.bandingPercentage)
        : isSet(object.banding_percentage)
        ? globalThis.Number(object.banding_percentage)
        : 0,
      thinningEfficiency: isSet(object.thinningEfficiency)
        ? globalThis.Number(object.thinningEfficiency)
        : isSet(object.thinning_efficiency)
        ? globalThis.Number(object.thinning_efficiency)
        : 0,
      cropId: isSet(object.cropId)
        ? globalThis.String(object.cropId)
        : isSet(object.crop_id)
        ? globalThis.String(object.crop_id)
        : "",
      crop: isSet(object.crop) ? globalThis.String(object.crop) : "",
      cropDensitySqFt: isSet(object.cropDensitySqFt)
        ? globalThis.Number(object.cropDensitySqFt)
        : isSet(object.crop_density_sq_ft)
        ? globalThis.Number(object.crop_density_sq_ft)
        : 0,
      avgCropSizeMm: isSet(object.avgCropSizeMm)
        ? globalThis.Number(object.avgCropSizeMm)
        : isSet(object.avg_crop_size_mm)
        ? globalThis.Number(object.avg_crop_size_mm)
        : 0,
      avgTargetableReqLaserTime: isSet(object.avgTargetableReqLaserTime)
        ? globalThis.Number(object.avgTargetableReqLaserTime)
        : isSet(object.avg_targetable_req_laser_time)
        ? globalThis.Number(object.avg_targetable_req_laser_time)
        : 0,
      avgUntargetableReqLaserTime: isSet(object.avgUntargetableReqLaserTime)
        ? globalThis.Number(object.avgUntargetableReqLaserTime)
        : isSet(object.avg_untargetable_req_laser_time)
        ? globalThis.Number(object.avg_untargetable_req_laser_time)
        : 0,
      validCrops: isSet(object.validCrops)
        ? globalThis.Number(object.validCrops)
        : isSet(object.valid_crops)
        ? globalThis.Number(object.valid_crops)
        : 0,
      operatorEffectiveness: isSet(object.operatorEffectiveness)
        ? globalThis.Number(object.operatorEffectiveness)
        : isSet(object.operator_effectiveness)
        ? globalThis.Number(object.operator_effectiveness)
        : 0,
      targetWeedingTimeSeconds: isSet(object.targetWeedingTimeSeconds)
        ? globalThis.Number(object.targetWeedingTimeSeconds)
        : isSet(object.target_weeding_time_seconds)
        ? globalThis.Number(object.target_weeding_time_seconds)
        : 0,
      embeddingsActiveUptimeSeconds: isSet(object.embeddingsActiveUptimeSeconds)
        ? globalThis.Number(object.embeddingsActiveUptimeSeconds)
        : isSet(object.embeddings_active_uptime_seconds)
        ? globalThis.Number(object.embeddings_active_uptime_seconds)
        : 0,
      customerId: isSet(object.customerId)
        ? globalThis.String(object.customerId)
        : isSet(object.customer_id)
        ? globalThis.String(object.customer_id)
        : "",
      jobStartTimestampMs: isSet(object.jobStartTimestampMs)
        ? globalThis.Number(object.jobStartTimestampMs)
        : isSet(object.job_start_timestamp_ms)
        ? globalThis.Number(object.job_start_timestamp_ms)
        : 0,
      jobStopTimestampMs: isSet(object.jobStopTimestampMs)
        ? globalThis.Number(object.jobStopTimestampMs)
        : isSet(object.job_stop_timestamp_ms)
        ? globalThis.Number(object.job_stop_timestamp_ms)
        : 0,
      jobCompleted: isSet(object.jobCompleted)
        ? globalThis.Boolean(object.jobCompleted)
        : isSet(object.job_completed)
        ? globalThis.Boolean(object.job_completed)
        : false,
      dataSource: isSet(object.dataSource)
        ? metricDataSourceFromJSON(object.dataSource)
        : isSet(object.data_source)
        ? metricDataSourceFromJSON(object.data_source)
        : 0,
      bandingProfiles: globalThis.Array.isArray(object?.bandingProfiles)
        ? object.bandingProfiles.map((e: any) => JigsawBandingProfile.fromJSON(e))
        : globalThis.Array.isArray(object?.banding_profiles)
        ? object.banding_profiles.map((e: any) => JigsawBandingProfile.fromJSON(e))
        : [],
      crops: globalThis.Array.isArray(object?.crops)
        ? object.crops.map((e: any) => JigsawCrop.fromJSON(e))
        : [],
      overallEfficiency: isSet(object.overallEfficiency)
        ? globalThis.Number(object.overallEfficiency)
        : isSet(object.overall_efficiency)
        ? globalThis.Number(object.overall_efficiency)
        : 0,
      totalWeedsInBand: isSet(object.totalWeedsInBand)
        ? globalThis.Number(object.totalWeedsInBand)
        : isSet(object.total_weeds_in_band)
        ? globalThis.Number(object.total_weeds_in_band)
        : 0,
      weedsTypeFractionBroadleaf: isSet(object.weedsTypeFractionBroadleaf)
        ? globalThis.Number(object.weedsTypeFractionBroadleaf)
        : isSet(object.weeds_type_fraction_broadleaf)
        ? globalThis.Number(object.weeds_type_fraction_broadleaf)
        : 0,
      weedsTypeFractionGrass: isSet(object.weedsTypeFractionGrass)
        ? globalThis.Number(object.weedsTypeFractionGrass)
        : isSet(object.weeds_type_fraction_grass)
        ? globalThis.Number(object.weeds_type_fraction_grass)
        : 0,
      weedsTypeFractionOffshoot: isSet(object.weedsTypeFractionOffshoot)
        ? globalThis.Number(object.weedsTypeFractionOffshoot)
        : isSet(object.weeds_type_fraction_offshoot)
        ? globalThis.Number(object.weeds_type_fraction_offshoot)
        : 0,
      weedsTypeFractionPurslane: isSet(object.weedsTypeFractionPurslane)
        ? globalThis.Number(object.weedsTypeFractionPurslane)
        : isSet(object.weeds_type_fraction_purslane)
        ? globalThis.Number(object.weeds_type_fraction_purslane)
        : 0,
      weedMetricsByCategory: isObject(object.weedMetricsByCategory)
        ? (globalThis.Object.entries(object.weedMetricsByCategory) as [string, any][]).reduce(
          (acc: { [key: string]: WeedMetrics }, [key, value]: [string, any]) => {
            acc[key] = WeedMetrics.fromJSON(value);
            return acc;
          },
          {},
        )
        : isObject(object.weed_metrics_by_category)
        ? (globalThis.Object.entries(object.weed_metrics_by_category) as [string, any][]).reduce(
          (acc: { [key: string]: WeedMetrics }, [key, value]: [string, any]) => {
            acc[key] = WeedMetrics.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
      jobFirstSeen: isSet(object.jobFirstSeen)
        ? globalThis.String(object.jobFirstSeen)
        : isSet(object.job_first_seen)
        ? globalThis.String(object.job_first_seen)
        : undefined,
      jobLastSeen: isSet(object.jobLastSeen)
        ? globalThis.String(object.jobLastSeen)
        : isSet(object.job_last_seen)
        ? globalThis.String(object.job_last_seen)
        : undefined,
      latestCrop: isSet(object.latestCrop)
        ? JigsawCrop.fromJSON(object.latestCrop)
        : isSet(object.latest_crop)
        ? JigsawCrop.fromJSON(object.latest_crop)
        : undefined,
      entryTimingGrade: isSet(object.entryTimingGrade)
        ? entryTimingGradeFromJSON(object.entryTimingGrade)
        : isSet(object.entry_timing_grade)
        ? entryTimingGradeFromJSON(object.entry_timing_grade)
        : 0,
      thinningProfiles: globalThis.Array.isArray(object?.thinningProfiles)
        ? object.thinningProfiles.map((e: any) => JigsawThinningProfile.fromJSON(e))
        : globalThis.Array.isArray(object?.thinning_profiles)
        ? object.thinning_profiles.map((e: any) => JigsawThinningProfile.fromJSON(e))
        : [],
    };
  },

  toJSON(message: JobMetricResponse): unknown {
    const obj: any = {};
    if (message.db !== undefined) {
      obj.db = DB.toJSON(message.db);
    }
    if (message.serial !== "") {
      obj.serial = message.serial;
    }
    if (message.date !== "") {
      obj.date = message.date;
    }
    if (message.jobId !== "") {
      obj.jobId = message.jobId;
    }
    if (message.jobName !== "") {
      obj.jobName = message.jobName;
    }
    if (message.acresWeeded !== 0) {
      obj.acresWeeded = message.acresWeeded;
    }
    if (message.avgSpeedMph !== 0) {
      obj.avgSpeedMph = message.avgSpeedMph;
    }
    if (message.avgWeedSizeMm !== 0) {
      obj.avgWeedSizeMm = message.avgWeedSizeMm;
    }
    if (message.bandingConfigName !== "") {
      obj.bandingConfigName = message.bandingConfigName;
    }
    if (message.bandingEnabled !== false) {
      obj.bandingEnabled = message.bandingEnabled;
    }
    if (message.coverageSpeedAcresHr !== 0) {
      obj.coverageSpeedAcresHr = message.coverageSpeedAcresHr;
    }
    if (message.distanceWeededMeters !== 0) {
      obj.distanceWeededMeters = message.distanceWeededMeters;
    }
    if (message.killedWeeds !== 0) {
      obj.killedWeeds = Math.round(message.killedWeeds);
    }
    if (message.missedWeeds !== 0) {
      obj.missedWeeds = Math.round(message.missedWeeds);
    }
    if (message.skippedWeeds !== 0) {
      obj.skippedWeeds = Math.round(message.skippedWeeds);
    }
    if (message.timeEfficiency !== 0) {
      obj.timeEfficiency = message.timeEfficiency;
    }
    if (message.totalWeeds !== 0) {
      obj.totalWeeds = Math.round(message.totalWeeds);
    }
    if (message.uptimeSeconds !== 0) {
      obj.uptimeSeconds = message.uptimeSeconds;
    }
    if (message.weedDensitySqFt !== 0) {
      obj.weedDensitySqFt = message.weedDensitySqFt;
    }
    if (message.weedingUptimeSeconds !== 0) {
      obj.weedingUptimeSeconds = message.weedingUptimeSeconds;
    }
    if (message.weedingEfficiency !== 0) {
      obj.weedingEfficiency = message.weedingEfficiency;
    }
    if (message.weedsTypeCountBroadleaf !== 0) {
      obj.weedsTypeCountBroadleaf = Math.round(message.weedsTypeCountBroadleaf);
    }
    if (message.weedsTypeCountGrass !== 0) {
      obj.weedsTypeCountGrass = Math.round(message.weedsTypeCountGrass);
    }
    if (message.weedsTypeCountOffshoot !== 0) {
      obj.weedsTypeCountOffshoot = Math.round(message.weedsTypeCountOffshoot);
    }
    if (message.weedsTypeCountPurslane !== 0) {
      obj.weedsTypeCountPurslane = Math.round(message.weedsTypeCountPurslane);
    }
    if (message.keptCrops !== 0) {
      obj.keptCrops = Math.round(message.keptCrops);
    }
    if (message.missedCrops !== 0) {
      obj.missedCrops = Math.round(message.missedCrops);
    }
    if (message.notThinning !== 0) {
      obj.notThinning = Math.round(message.notThinning);
    }
    if (message.notWeeding !== 0) {
      obj.notWeeding = Math.round(message.notWeeding);
    }
    if (message.skippedCrops !== 0) {
      obj.skippedCrops = Math.round(message.skippedCrops);
    }
    if (message.thinnedCrops !== 0) {
      obj.thinnedCrops = Math.round(message.thinnedCrops);
    }
    if (message.totalCrops !== 0) {
      obj.totalCrops = Math.round(message.totalCrops);
    }
    if (message.bandingPercentage !== 0) {
      obj.bandingPercentage = message.bandingPercentage;
    }
    if (message.thinningEfficiency !== 0) {
      obj.thinningEfficiency = message.thinningEfficiency;
    }
    if (message.cropId !== "") {
      obj.cropId = message.cropId;
    }
    if (message.crop !== "") {
      obj.crop = message.crop;
    }
    if (message.cropDensitySqFt !== 0) {
      obj.cropDensitySqFt = message.cropDensitySqFt;
    }
    if (message.avgCropSizeMm !== 0) {
      obj.avgCropSizeMm = message.avgCropSizeMm;
    }
    if (message.avgTargetableReqLaserTime !== 0) {
      obj.avgTargetableReqLaserTime = Math.round(message.avgTargetableReqLaserTime);
    }
    if (message.avgUntargetableReqLaserTime !== 0) {
      obj.avgUntargetableReqLaserTime = Math.round(message.avgUntargetableReqLaserTime);
    }
    if (message.validCrops !== 0) {
      obj.validCrops = Math.round(message.validCrops);
    }
    if (message.operatorEffectiveness !== 0) {
      obj.operatorEffectiveness = message.operatorEffectiveness;
    }
    if (message.targetWeedingTimeSeconds !== 0) {
      obj.targetWeedingTimeSeconds = Math.round(message.targetWeedingTimeSeconds);
    }
    if (message.embeddingsActiveUptimeSeconds !== 0) {
      obj.embeddingsActiveUptimeSeconds = message.embeddingsActiveUptimeSeconds;
    }
    if (message.customerId !== "") {
      obj.customerId = message.customerId;
    }
    if (message.jobStartTimestampMs !== 0) {
      obj.jobStartTimestampMs = Math.round(message.jobStartTimestampMs);
    }
    if (message.jobStopTimestampMs !== 0) {
      obj.jobStopTimestampMs = Math.round(message.jobStopTimestampMs);
    }
    if (message.jobCompleted !== false) {
      obj.jobCompleted = message.jobCompleted;
    }
    if (message.dataSource !== 0) {
      obj.dataSource = metricDataSourceToJSON(message.dataSource);
    }
    if (message.bandingProfiles?.length) {
      obj.bandingProfiles = message.bandingProfiles.map((e) => JigsawBandingProfile.toJSON(e));
    }
    if (message.crops?.length) {
      obj.crops = message.crops.map((e) => JigsawCrop.toJSON(e));
    }
    if (message.overallEfficiency !== 0) {
      obj.overallEfficiency = message.overallEfficiency;
    }
    if (message.totalWeedsInBand !== 0) {
      obj.totalWeedsInBand = message.totalWeedsInBand;
    }
    if (message.weedsTypeFractionBroadleaf !== 0) {
      obj.weedsTypeFractionBroadleaf = message.weedsTypeFractionBroadleaf;
    }
    if (message.weedsTypeFractionGrass !== 0) {
      obj.weedsTypeFractionGrass = message.weedsTypeFractionGrass;
    }
    if (message.weedsTypeFractionOffshoot !== 0) {
      obj.weedsTypeFractionOffshoot = message.weedsTypeFractionOffshoot;
    }
    if (message.weedsTypeFractionPurslane !== 0) {
      obj.weedsTypeFractionPurslane = message.weedsTypeFractionPurslane;
    }
    if (message.weedMetricsByCategory) {
      const entries = globalThis.Object.entries(message.weedMetricsByCategory) as [string, WeedMetrics][];
      if (entries.length > 0) {
        obj.weedMetricsByCategory = {};
        entries.forEach(([k, v]) => {
          obj.weedMetricsByCategory[k] = WeedMetrics.toJSON(v);
        });
      }
    }
    if (message.jobFirstSeen !== undefined) {
      obj.jobFirstSeen = message.jobFirstSeen;
    }
    if (message.jobLastSeen !== undefined) {
      obj.jobLastSeen = message.jobLastSeen;
    }
    if (message.latestCrop !== undefined) {
      obj.latestCrop = JigsawCrop.toJSON(message.latestCrop);
    }
    if (message.entryTimingGrade !== 0) {
      obj.entryTimingGrade = entryTimingGradeToJSON(message.entryTimingGrade);
    }
    if (message.thinningProfiles?.length) {
      obj.thinningProfiles = message.thinningProfiles.map((e) => JigsawThinningProfile.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JobMetricResponse>, I>>(base?: I): JobMetricResponse {
    return JobMetricResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JobMetricResponse>, I>>(object: I): JobMetricResponse {
    const message = createBaseJobMetricResponse();
    message.db = (object.db !== undefined && object.db !== null) ? DB.fromPartial(object.db) : undefined;
    message.serial = object.serial ?? "";
    message.date = object.date ?? "";
    message.jobId = object.jobId ?? "";
    message.jobName = object.jobName ?? "";
    message.acresWeeded = object.acresWeeded ?? 0;
    message.avgSpeedMph = object.avgSpeedMph ?? 0;
    message.avgWeedSizeMm = object.avgWeedSizeMm ?? 0;
    message.bandingConfigName = object.bandingConfigName ?? "";
    message.bandingEnabled = object.bandingEnabled ?? false;
    message.coverageSpeedAcresHr = object.coverageSpeedAcresHr ?? 0;
    message.distanceWeededMeters = object.distanceWeededMeters ?? 0;
    message.killedWeeds = object.killedWeeds ?? 0;
    message.missedWeeds = object.missedWeeds ?? 0;
    message.skippedWeeds = object.skippedWeeds ?? 0;
    message.timeEfficiency = object.timeEfficiency ?? 0;
    message.totalWeeds = object.totalWeeds ?? 0;
    message.uptimeSeconds = object.uptimeSeconds ?? 0;
    message.weedDensitySqFt = object.weedDensitySqFt ?? 0;
    message.weedingUptimeSeconds = object.weedingUptimeSeconds ?? 0;
    message.weedingEfficiency = object.weedingEfficiency ?? 0;
    message.weedsTypeCountBroadleaf = object.weedsTypeCountBroadleaf ?? 0;
    message.weedsTypeCountGrass = object.weedsTypeCountGrass ?? 0;
    message.weedsTypeCountOffshoot = object.weedsTypeCountOffshoot ?? 0;
    message.weedsTypeCountPurslane = object.weedsTypeCountPurslane ?? 0;
    message.keptCrops = object.keptCrops ?? 0;
    message.missedCrops = object.missedCrops ?? 0;
    message.notThinning = object.notThinning ?? 0;
    message.notWeeding = object.notWeeding ?? 0;
    message.skippedCrops = object.skippedCrops ?? 0;
    message.thinnedCrops = object.thinnedCrops ?? 0;
    message.totalCrops = object.totalCrops ?? 0;
    message.bandingPercentage = object.bandingPercentage ?? 0;
    message.thinningEfficiency = object.thinningEfficiency ?? 0;
    message.cropId = object.cropId ?? "";
    message.crop = object.crop ?? "";
    message.cropDensitySqFt = object.cropDensitySqFt ?? 0;
    message.avgCropSizeMm = object.avgCropSizeMm ?? 0;
    message.avgTargetableReqLaserTime = object.avgTargetableReqLaserTime ?? 0;
    message.avgUntargetableReqLaserTime = object.avgUntargetableReqLaserTime ?? 0;
    message.validCrops = object.validCrops ?? 0;
    message.operatorEffectiveness = object.operatorEffectiveness ?? 0;
    message.targetWeedingTimeSeconds = object.targetWeedingTimeSeconds ?? 0;
    message.embeddingsActiveUptimeSeconds = object.embeddingsActiveUptimeSeconds ?? 0;
    message.customerId = object.customerId ?? "";
    message.jobStartTimestampMs = object.jobStartTimestampMs ?? 0;
    message.jobStopTimestampMs = object.jobStopTimestampMs ?? 0;
    message.jobCompleted = object.jobCompleted ?? false;
    message.dataSource = object.dataSource ?? 0;
    message.bandingProfiles = object.bandingProfiles?.map((e) => JigsawBandingProfile.fromPartial(e)) || [];
    message.crops = object.crops?.map((e) => JigsawCrop.fromPartial(e)) || [];
    message.overallEfficiency = object.overallEfficiency ?? 0;
    message.totalWeedsInBand = object.totalWeedsInBand ?? 0;
    message.weedsTypeFractionBroadleaf = object.weedsTypeFractionBroadleaf ?? 0;
    message.weedsTypeFractionGrass = object.weedsTypeFractionGrass ?? 0;
    message.weedsTypeFractionOffshoot = object.weedsTypeFractionOffshoot ?? 0;
    message.weedsTypeFractionPurslane = object.weedsTypeFractionPurslane ?? 0;
    message.weedMetricsByCategory =
      (globalThis.Object.entries(object.weedMetricsByCategory ?? {}) as [string, WeedMetrics][]).reduce(
        (acc: { [key: string]: WeedMetrics }, [key, value]: [string, WeedMetrics]) => {
          if (value !== undefined) {
            acc[key] = WeedMetrics.fromPartial(value);
          }
          return acc;
        },
        {},
      );
    message.jobFirstSeen = object.jobFirstSeen ?? undefined;
    message.jobLastSeen = object.jobLastSeen ?? undefined;
    message.latestCrop = (object.latestCrop !== undefined && object.latestCrop !== null)
      ? JigsawCrop.fromPartial(object.latestCrop)
      : undefined;
    message.entryTimingGrade = object.entryTimingGrade ?? 0;
    message.thinningProfiles = object.thinningProfiles?.map((e) => JigsawThinningProfile.fromPartial(e)) || [];
    return message;
  },
};

function createBaseJobMetricResponse_WeedMetricsByCategoryEntry(): JobMetricResponse_WeedMetricsByCategoryEntry {
  return { key: "", value: undefined };
}

export const JobMetricResponse_WeedMetricsByCategoryEntry: MessageFns<JobMetricResponse_WeedMetricsByCategoryEntry> = {
  encode(
    message: JobMetricResponse_WeedMetricsByCategoryEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      WeedMetrics.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JobMetricResponse_WeedMetricsByCategoryEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJobMetricResponse_WeedMetricsByCategoryEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = WeedMetrics.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JobMetricResponse_WeedMetricsByCategoryEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? WeedMetrics.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: JobMetricResponse_WeedMetricsByCategoryEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = WeedMetrics.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JobMetricResponse_WeedMetricsByCategoryEntry>, I>>(
    base?: I,
  ): JobMetricResponse_WeedMetricsByCategoryEntry {
    return JobMetricResponse_WeedMetricsByCategoryEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JobMetricResponse_WeedMetricsByCategoryEntry>, I>>(
    object: I,
  ): JobMetricResponse_WeedMetricsByCategoryEntry {
    const message = createBaseJobMetricResponse_WeedMetricsByCategoryEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? WeedMetrics.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseJobMetricsByJobResponse(): JobMetricsByJobResponse {
  return { metrics: {} };
}

export const JobMetricsByJobResponse: MessageFns<JobMetricsByJobResponse> = {
  encode(message: JobMetricsByJobResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.metrics).forEach(([key, value]: [string, JobMetricResponse]) => {
      JobMetricsByJobResponse_MetricsEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JobMetricsByJobResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJobMetricsByJobResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = JobMetricsByJobResponse_MetricsEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.metrics[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JobMetricsByJobResponse {
    return {
      metrics: isObject(object.metrics)
        ? (globalThis.Object.entries(object.metrics) as [string, any][]).reduce(
          (acc: { [key: string]: JobMetricResponse }, [key, value]: [string, any]) => {
            acc[key] = JobMetricResponse.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: JobMetricsByJobResponse): unknown {
    const obj: any = {};
    if (message.metrics) {
      const entries = globalThis.Object.entries(message.metrics) as [string, JobMetricResponse][];
      if (entries.length > 0) {
        obj.metrics = {};
        entries.forEach(([k, v]) => {
          obj.metrics[k] = JobMetricResponse.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JobMetricsByJobResponse>, I>>(base?: I): JobMetricsByJobResponse {
    return JobMetricsByJobResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JobMetricsByJobResponse>, I>>(object: I): JobMetricsByJobResponse {
    const message = createBaseJobMetricsByJobResponse();
    message.metrics = (globalThis.Object.entries(object.metrics ?? {}) as [string, JobMetricResponse][]).reduce(
      (acc: { [key: string]: JobMetricResponse }, [key, value]: [string, JobMetricResponse]) => {
        if (value !== undefined) {
          acc[key] = JobMetricResponse.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseJobMetricsByJobResponse_MetricsEntry(): JobMetricsByJobResponse_MetricsEntry {
  return { key: "", value: undefined };
}

export const JobMetricsByJobResponse_MetricsEntry: MessageFns<JobMetricsByJobResponse_MetricsEntry> = {
  encode(message: JobMetricsByJobResponse_MetricsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      JobMetricResponse.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JobMetricsByJobResponse_MetricsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJobMetricsByJobResponse_MetricsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = JobMetricResponse.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JobMetricsByJobResponse_MetricsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? JobMetricResponse.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: JobMetricsByJobResponse_MetricsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = JobMetricResponse.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JobMetricsByJobResponse_MetricsEntry>, I>>(
    base?: I,
  ): JobMetricsByJobResponse_MetricsEntry {
    return JobMetricsByJobResponse_MetricsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JobMetricsByJobResponse_MetricsEntry>, I>>(
    object: I,
  ): JobMetricsByJobResponse_MetricsEntry {
    const message = createBaseJobMetricsByJobResponse_MetricsEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? JobMetricResponse.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseJobMetricsByJobsByRobotResponse(): JobMetricsByJobsByRobotResponse {
  return { metrics: {} };
}

export const JobMetricsByJobsByRobotResponse: MessageFns<JobMetricsByJobsByRobotResponse> = {
  encode(message: JobMetricsByJobsByRobotResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.metrics).forEach(([key, value]: [string, JobMetricsByJobResponse]) => {
      JobMetricsByJobsByRobotResponse_MetricsEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JobMetricsByJobsByRobotResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJobMetricsByJobsByRobotResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = JobMetricsByJobsByRobotResponse_MetricsEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.metrics[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JobMetricsByJobsByRobotResponse {
    return {
      metrics: isObject(object.metrics)
        ? (globalThis.Object.entries(object.metrics) as [string, any][]).reduce(
          (acc: { [key: string]: JobMetricsByJobResponse }, [key, value]: [string, any]) => {
            acc[key] = JobMetricsByJobResponse.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: JobMetricsByJobsByRobotResponse): unknown {
    const obj: any = {};
    if (message.metrics) {
      const entries = globalThis.Object.entries(message.metrics) as [string, JobMetricsByJobResponse][];
      if (entries.length > 0) {
        obj.metrics = {};
        entries.forEach(([k, v]) => {
          obj.metrics[k] = JobMetricsByJobResponse.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JobMetricsByJobsByRobotResponse>, I>>(base?: I): JobMetricsByJobsByRobotResponse {
    return JobMetricsByJobsByRobotResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JobMetricsByJobsByRobotResponse>, I>>(
    object: I,
  ): JobMetricsByJobsByRobotResponse {
    const message = createBaseJobMetricsByJobsByRobotResponse();
    message.metrics = (globalThis.Object.entries(object.metrics ?? {}) as [string, JobMetricsByJobResponse][]).reduce(
      (acc: { [key: string]: JobMetricsByJobResponse }, [key, value]: [string, JobMetricsByJobResponse]) => {
        if (value !== undefined) {
          acc[key] = JobMetricsByJobResponse.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseJobMetricsByJobsByRobotResponse_MetricsEntry(): JobMetricsByJobsByRobotResponse_MetricsEntry {
  return { key: "", value: undefined };
}

export const JobMetricsByJobsByRobotResponse_MetricsEntry: MessageFns<JobMetricsByJobsByRobotResponse_MetricsEntry> = {
  encode(
    message: JobMetricsByJobsByRobotResponse_MetricsEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      JobMetricsByJobResponse.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JobMetricsByJobsByRobotResponse_MetricsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJobMetricsByJobsByRobotResponse_MetricsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = JobMetricsByJobResponse.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JobMetricsByJobsByRobotResponse_MetricsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? JobMetricsByJobResponse.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: JobMetricsByJobsByRobotResponse_MetricsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = JobMetricsByJobResponse.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JobMetricsByJobsByRobotResponse_MetricsEntry>, I>>(
    base?: I,
  ): JobMetricsByJobsByRobotResponse_MetricsEntry {
    return JobMetricsByJobsByRobotResponse_MetricsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JobMetricsByJobsByRobotResponse_MetricsEntry>, I>>(
    object: I,
  ): JobMetricsByJobsByRobotResponse_MetricsEntry {
    const message = createBaseJobMetricsByJobsByRobotResponse_MetricsEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? JobMetricsByJobResponse.fromPartial(object.value)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(dateStr: string): Timestamp {
  const date = new globalThis.Date(dateStr);
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): string {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis).toISOString();
}

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
